"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ABSOLUTE_TIME_OPERATORS: () => ABSOLUTE_TIME_OPERATORS,
  ALL_OPERATORS: () => ALL_OPERATORS,
  AUDIENCES_CLAUSES: () => AUDIENCES_CLAUSES,
  AndCondition: () => AndCondition,
  AndShape: () => AndShape,
  AppShape: () => AppShape,
  AttributesShape: () => AttributesShape,
  CLAUSE_TYPES: () => CLAUSE_TYPES,
  ChecklistsShape: () => ChecklistsShape,
  ConditionText: () => ConditionText,
  Conditions: () => Conditions_default,
  ConditionsPropsShape: () => ConditionsPropsShape,
  ConditionsShape: () => ConditionsShape,
  ContentShape: () => ContentShape,
  DEFAULT_OPERATORS: () => DEFAULT_OPERATORS,
  DomainsShape: () => DomainsShape,
  EXISTENTIAL_OPERATORS: () => EXISTENTIAL_OPERATORS,
  EventShape: () => EventShape,
  ExperienceShape: () => ExperienceShape,
  ExperienceStepShape: () => ExperienceStepShape,
  FrequencyShape: () => FrequencyShape,
  GroupsShape: () => GroupsShape,
  Highlight: () => Highlight,
  LANGUAGE_OPTIONS: () => LANGUAGE_OPTIONS,
  LanguagesShape: () => LanguagesShape,
  MILLISECONDS_PER_DAY: () => MILLISECONDS_PER_DAY,
  MULTI_VALUE_OPERATORS: () => MULTI_VALUE_OPERATORS,
  NUMERIC_OPERATORS: () => NUMERIC_OPERATORS,
  NotShape: () => NotShape,
  OPERATORS: () => OPERATORS,
  OptionShape: () => OptionShape,
  OrCondition: () => OrCondition,
  OrShape: () => OrShape,
  PROPERTY_CLAUSE_OPERATORS: () => PROPERTY_CLAUSE_OPERATORS,
  PropertiesShape: () => PropertiesShape,
  RELATIVE_TIME_OPERATORS: () => RELATIVE_TIME_OPERATORS,
  ReadableConditions: () => ReadableConditions_default,
  STEP_TYPE_IDS: () => STEP_TYPE_IDS,
  ScreenShape: () => ScreenShape,
  SegmentsShape: () => SegmentsShape,
  SelectOptionsShape: () => SelectOptionsShape,
  Shape: () => Shape,
  SubGroup: () => SubGroup,
  TriggerShape: () => TriggerShape,
  URLShape: () => URLShape,
  VersionShape: () => VersionShape,
  allowed: () => allowed,
  conditionsSchema: () => schema_default,
  evaluate: () => evaluate,
  filterImmutableExperienceSections: () => filterImmutableExperienceSections,
  getAudienceConditions: () => getAudienceConditions,
  getBannerTargetingSections: () => getBannerTargetingSections,
  getCompletionEventLabel: () => getCompletionEventLabel,
  getDomains: () => getDomains,
  getLaunchpadTargetingSections: () => getLaunchpadTargetingSections,
  getLeafNodes: () => getLeafNodes,
  getMobileTargetingSections: () => getMobileTargetingSections,
  getPinTargetingSections: () => getPinTargetingSections,
  getSegments: () => getSegments,
  hasMatchingSegment: () => hasMatchingSegment,
  isGroupList: () => isGroupList,
  isGroupOption: () => isGroupOption,
  parse: () => parse
});
module.exports = __toCommonJS(src_exports);

// src/components/ReadableConditions/ReadableConditions.jsx
var import_react36 = __toESM(require("react"));
var import_prop_types15 = __toESM(require("prop-types"));

// src/components/shape.js
var import_prop_types = __toESM(require("prop-types"));
var import_lodash = __toESM(require("lodash.pick"));

// src/components/Group.tsx
var import_react22 = require("react");
var import_legacy_components19 = require("@studio/legacy-components");

// src/components/UrlClause.tsx
var import_react = require("react");
var import_legacy_components2 = require("@studio/legacy-components");

// src/components/constants/operators.js
var OPERATORS = {
  EQUALS: { label: "equals", value: "==" },
  DOESNT_EQUAL: { label: "doesn't equal", value: "!=" },
  CONTAINS: { label: "contains", value: "*" },
  DOESNT_CONTAIN: { label: "doesn't contain", value: "!*" },
  STARTS_WITH: { label: "starts with", value: "^" },
  DOESNT_START_WITH: { label: "doesn't start with", value: "!^" },
  ENDS_WITH: { label: "ends with", value: "$" },
  DOESNT_END_WITH: { label: "doesn't end with", value: "!$" },
  EXISTS: { label: "exists", value: "?" },
  DOESNT_EXIST: { label: "doesn't exist", value: "!?" },
  IS_ONE_OF: { label: "is one of", value: "in" },
  ISNT_ONE_OF: { label: "isn't one of", value: "not in" },
  IS_GREATER_THAN: { label: "is greater than", value: ">" },
  IS_GREATER_OR_EQUAL: { label: "greater than or equal to", value: ">=" },
  IS_LESS_THAN: { label: "is less than", value: "<" },
  IS_LESS_OR_EQUAL: { label: "less than or equal to", value: "<=" },
  OCCURRED_MORE_THAN: { label: "occurred more than", value: "> ago" },
  OCCURRED_LESS_THAN: { label: "occurred less than", value: "< ago" },
  OCCURRED_IN_THE_LAST: {
    label: "will occur within the next",
    value: "within"
  },
  OCCURRED_BEFORE: { label: "occurred before", value: "< time" },
  OCCURRED_AFTER: { label: "occurred after", value: "> time" },
  MATCHES_REGEX: { label: "matches regex", value: "regex" }
};
var PROPERTY_CLAUSE_OPERATORS = [
  OPERATORS.EQUALS,
  OPERATORS.DOESNT_EQUAL,
  OPERATORS.CONTAINS,
  OPERATORS.DOESNT_CONTAIN
];
var ALL_OPERATORS = Object.values(OPERATORS);
var DEFAULT_OPERATORS = /* @__PURE__ */ new Set([
  "==",
  "!=",
  "*",
  "!*",
  "^",
  "!^",
  "$",
  "!$",
  "regex"
]);
var MULTI_VALUE_OPERATORS = /* @__PURE__ */ new Set(["in", "not in"]);
var NUMERIC_OPERATORS = /* @__PURE__ */ new Set([">", "<", "<=", ">="]);
var RELATIVE_TIME_OPERATORS = /* @__PURE__ */ new Set(["> ago", "< ago", "within"]);
var ABSOLUTE_TIME_OPERATORS = /* @__PURE__ */ new Set(["> time", "< time"]);
var EXISTENTIAL_OPERATORS = /* @__PURE__ */ new Set(["?", "!?"]);

// src/components/styled.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_legacy_components = require("@studio/legacy-components");
var UpgradeBadge = (0, import_styled_components.default)(import_legacy_components.StatusLabel)`
  font-weight: var(--normal);
  word-break: keep-all;
  user-select: none;
`;
var ConditionsWrapper = import_styled_components.default.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-bottom: 16px;

  > ${import_legacy_components.Select} {
    max-width: unset;
    min-width: unset;
  }
`;
var Bracket = import_styled_components.default.div`
  align-self: stretch;
  border: 2px solid
    ${({ type }) => type === "and" ? "var(--blurple)" : "var(--sea-monsters)"};
  border-right-width: 0;
  display: flex;
  margin: 9px 0 20px 0;
  min-width: 45px;
`;
var BracketWrapper = import_styled_components.default.div`
  align-items: center;
  display: flex;
  min-width: 70px;

  > ${import_legacy_components.Select} {
    min-width: 70px;
  }

  > ${Bracket} {
    margin-left: -35px;
  }
`;
var Content = import_styled_components.default.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
var Child = import_styled_components.default.div`
  --options-margin: calc(11em + 12px); // width of first Select + gap

  display: flex;
  justify-content: flex-start;
  gap: 12px;
  position: relative;

  ${import_legacy_components.Select} {
    min-width: 11em;
    height: 40px;
  }

  ${import_legacy_components.IconButton} {
    height: 40px;
  }
`;
var Children = import_styled_components.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > ${ConditionsWrapper} {
    padding-bottom: 0;
  }
`;
var ConditionsType = import_styled_components.default.span`
  align-items: center;
  color: var(--pleather);
  display: flex;
  font-weight: var(--bold);
`;
var ClauseWrapper = import_styled_components.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;

  ${import_legacy_components.TextArea} {
    margin-left: calc(-1 * var(--options-margin));
    resize: vertical;
    width: calc(
      100% + var(--options-margin) + 32px
    ); // final value is button width + gap
  }
`;
var Clause = import_styled_components.default.div.attrs({
  className: "conditions-clause__wrapper"
})`
  display: flex;
  align-items: center;
  gap: 12px;

  ${import_legacy_components.Select} {
    &:first-child {
      min-width: 15em;
    }

    ${UpgradeBadge} {
      margin-top: 6px;
    }
  }

  ${import_legacy_components.Select}, ${import_legacy_components.Input}, ${import_legacy_components.DateInput}, ${import_legacy_components.DataList} {
    &:nth-last-child(2),
    &:last-of-type {
      min-width: 15em;
    }
  }
`;
var TimeframeWrapper = import_styled_components.default.div`
  align-items: center;
  display: flex;
  gap: 6px;
  margin-left: calc(-1 * var(--options-margin));

  ${import_legacy_components.Input}[type=number] {
    width: 6em;
  }

  > ${import_legacy_components.Select} {
    min-width: 12em;
  }
`;
var VersionClauseWrapper = import_styled_components.default.div`
  ${import_legacy_components.WarningNotice} {
    margin-top: 16px;
    max-width: calc(30em + 12px);

    > div {
      line-height: var(--large);
    }
  }
`;
var Wrapper = import_styled_components.default.div``;
var ToggleButton = (0, import_styled_components.default)(import_legacy_components.Button)`
  min-width: 186px;
`;
var TextAreaWrapper = import_styled_components.default.div`
  width: 100%;
  margin-top: 4px;
`;

// src/components/UrlClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var URL_OPERATORS = [
  OPERATORS.STARTS_WITH,
  OPERATORS.DOESNT_START_WITH,
  OPERATORS.ENDS_WITH,
  OPERATORS.DOESNT_END_WITH,
  OPERATORS.CONTAINS,
  OPERATORS.DOESNT_CONTAIN,
  OPERATORS.EQUALS,
  OPERATORS.DOESNT_EQUAL,
  OPERATORS.MATCHES_REGEX
];
var getPrefixedValue = (operator, value) => {
  const prefixedOperators = [
    OPERATORS.STARTS_WITH,
    OPERATORS.DOESNT_START_WITH,
    OPERATORS.EQUALS,
    OPERATORS.DOESNT_EQUAL
  ].map(({ value: operatorValue }) => operatorValue);
  if (prefixedOperators.includes(operator) && !value.startsWith("/")) {
    return `/${value}`;
  }
  return value;
};
var UrlClause = ({ conditions, onChange }) => {
  const valueRef = (0, import_react.useRef)();
  const {
    url: { operator: currentOperator, value: currentValue = "" }
  } = conditions;
  (0, import_react.useEffect)(() => {
    if (valueRef.current) {
      valueRef.current.value = currentValue;
    }
  }, [currentValue]);
  const handleChange = (changes) => void onChange({
    url: { ...conditions.url, ...changes }
  });
  const handleOperatorChange = ({
    value: operator
  }) => void handleChange({
    operator,
    value: getPrefixedValue(operator, currentValue)
  });
  const handleValueBlur = ({
    target: { value }
  }) => {
    const prefixedValue = getPrefixedValue(currentOperator, value.trim());
    if (valueRef.current) {
      valueRef.current.value = prefixedValue;
    }
    void handleChange({ value: prefixedValue });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components2.Select, {
        name: "operator",
        value: URL_OPERATORS.find(({ value }) => value === currentOperator),
        options: URL_OPERATORS,
        onChange: handleOperatorChange,
        portal: true,
        menuShouldBlockScroll: true
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components2.Input, {
        type: "text",
        "aria-label": "value",
        name: "value",
        ref: valueRef,
        defaultValue: currentValue,
        placeholder: "e.g. /account",
        onBlur: handleValueBlur
      })
    ]
  });
};

// src/components/PropertiesClause.tsx
var import_react7 = require("react");
var import_legacy_components4 = require("@studio/legacy-components");

// src/types/context.ts
function isGroupList(list) {
  return list.some((option) => "options" in option);
}
function isGroupOption(option) {
  return "options" in option;
}

// src/lib/use-storage-toggle.js
var import_react2 = require("react");
var useStorageToggle = (pageKey) => {
  const [showOptions, setShowOptions] = (0, import_react2.useState)(false);
  (0, import_react2.useLayoutEffect)(() => {
    const storedValue = sessionStorage.getItem(pageKey);
    if (storedValue !== null) {
      setShowOptions(storedValue === "true");
    }
  }, [pageKey]);
  const toggleShowOptions = () => {
    setShowOptions((prev) => {
      const newValue = !prev;
      sessionStorage.setItem(pageKey, newValue ? "true" : "false");
      return newValue;
    });
  };
  return [showOptions, toggleShowOptions];
};

// src/lib/property.js
var getPropertyDisplayName = (prop) => {
  return prop == null ? void 0 : prop.replace(/^_appcuesForm_/g, "Form Response: ").replace(/^_appcuesSatisfaction_/g, "").replace(/^_/, "").replace(/[+._-]/g, " ").replace(/([a-z]+)([A-Z]+)/g, (m, g1, g2) => {
    return `${g1} ${g2}`;
  }).replace(/(\s?)([A-Z])([a-z]+)/g, (m, g1, g2, g3) => {
    return ` ${g2}${g3}`;
  }).trim().toLowerCase().replace(/\b(id|url|os|ip|eid|fb|crm|uuid|nps)\b/gi, (m, g1) => {
    return `${g1.toUpperCase()}`;
  }).replace(/(\w)(\w*)/g, (m, g1, g2) => {
    return `${g1.toUpperCase()}${g2}`;
  }).trim();
};
var getOptGroup = (propName) => {
  if (!propName) {
    return null;
  }
  if (/^(_deviceType|_operatingSystem|_browser)/.test(propName)) {
    return "device";
  }
  if (propName.startsWith("_appcuesForm_")) {
    return "form";
  }
  if (propName.startsWith("_appcuesSatisfaction_")) {
    return "satisfaction";
  }
  if (propName.startsWith("_")) {
    return "auto";
  }
  return "normal";
};
var groupProfileAttributes = (attributes) => {
  return attributes.reduce(
    (acc, attribute) => {
      const group = getOptGroup(attribute.value);
      if (group) {
        acc[group].options.push(attribute);
      } else {
        acc.normal.options.push(attribute);
      }
      return acc;
    },
    {
      normal: {
        label: "CUSTOM PROPERTIES",
        options: []
      },
      form: {
        label: "FORM RESPONSES",
        options: []
      },
      device: {
        label: "DEVICE PROPERTIES",
        options: []
      },
      satisfaction: {
        label: "USER SATISFACTION",
        options: []
      },
      auto: {
        label: "AUTO-PROPERTIES",
        options: []
      }
    }
  );
};

// src/components/use-property-conditions.js
var import_react3 = require("react");
var import_legacy_components3 = require("@studio/legacy-components");

// src/components/constants/datetime.js
var MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1e3;

// src/components/use-property-conditions.js
var use_property_conditions_default = (innerConditions, onChange) => {
  const { operator, value } = innerConditions;
  const hasOptions = MULTI_VALUE_OPERATORS.has(operator);
  const isRelativeTimeOperator = RELATIVE_TIME_OPERATORS.has(operator);
  const isAbsoluteTimeOperator = ABSOLUTE_TIME_OPERATORS.has(operator);
  const isNumericOperator = NUMERIC_OPERATORS.has(operator);
  const isDefaultOperator = DEFAULT_OPERATORS.has(operator);
  const isMultiValueOperator = MULTI_VALUE_OPERATORS.has(operator);
  const isExistentialOperator = EXISTENTIAL_OPERATORS.has(operator);
  const [draftValue, setDraftValue] = (0, import_react3.useState)(value);
  const handleCurrentValueChange = ({ target: { value: nextValue } }) => {
    if (isMultiValueOperator) {
      setDraftValue(
        nextValue.replace(/(\s*,\s*)|\n/g, ",\n").replace(/\s*,\s*/g, ",").replace(/(^[\t ]*\n*\s+$)/gm, "").split(",").join("\n")
      );
    } else {
      setDraftValue(nextValue);
    }
  };
  (0, import_react3.useEffect)(() => {
    if (isRelativeTimeOperator) {
      setDraftValue(value / MILLISECONDS_PER_DAY);
    } else {
      setDraftValue(value);
    }
  }, [isRelativeTimeOperator, value]);
  const handlePropertyChange = ({ value: newProperty }) => void onChange({ ...innerConditions, property: newProperty });
  const handleOperatorChange = ({ value: newOperator }) => {
    let nextValue = value;
    if (MULTI_VALUE_OPERATORS.has(newOperator) && !isMultiValueOperator) {
      nextValue = "";
    }
    if (NUMERIC_OPERATORS.has(newOperator) && !isNumericOperator) {
      nextValue = 1;
    }
    if (RELATIVE_TIME_OPERATORS.has(newOperator) && !isRelativeTimeOperator) {
      nextValue = 24 * 60 * 60 * 1e3;
    }
    if (ABSOLUTE_TIME_OPERATORS.has(newOperator) && !isAbsoluteTimeOperator) {
      nextValue = (0, import_legacy_components3.startOf)(new Date(), "day").valueOf();
    }
    if (EXISTENTIAL_OPERATORS.has(newOperator)) {
      nextValue = null;
    }
    if (DEFAULT_OPERATORS.has(newOperator) && !isDefaultOperator) {
      nextValue = "";
    }
    onChange({
      ...innerConditions,
      operator: newOperator,
      value: nextValue
    });
  };
  const handleValueAsDateChange = (newValue) => void onChange({
    ...innerConditions,
    value: (0, import_legacy_components3.startOf)(newValue, "day").valueOf()
  });
  const handleValueBlur = ({ target: { value: newValue, valueAsNumber } }) => {
    let nextValue = newValue;
    if (isRelativeTimeOperator) {
      const numberOfDays = valueAsNumber || 1;
      nextValue = numberOfDays * MILLISECONDS_PER_DAY;
    }
    if (isNumericOperator) {
      nextValue = valueAsNumber || 1;
    }
    onChange({ ...innerConditions, value: nextValue });
  };
  const handleValueSelected = ({ selectedItem }) => void onChange({ ...innerConditions, value: selectedItem });
  return {
    draftValue,
    hasOptions,
    isRelativeTimeOperator,
    isAbsoluteTimeOperator,
    isNumericOperator,
    isDefaultOperator,
    isMultiValueOperator,
    isExistentialOperator,
    onPropertyChange: handlePropertyChange,
    onOperatorChange: handleOperatorChange,
    onValueChange: handleCurrentValueChange,
    onDateChange: handleValueAsDateChange,
    onValueBlur: handleValueBlur,
    onValueSelected: handleValueSelected
  };
};

// src/components/use-suggestions.ts
var import_react6 = require("react");

// src/components/use-debounce.ts
var import_react4 = require("react");
function useDebounce(value, milliSeconds) {
  const [debouncedValue, setDebouncedValue] = (0, import_react4.useState)(value);
  (0, import_react4.useEffect)(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, milliSeconds);
    return () => {
      clearTimeout(handler);
    };
  }, [value, milliSeconds]);
  return debouncedValue;
}

// src/components/ConditionsContext.ts
var import_react5 = require("react");
var ConditionsContext = (0, import_react5.createContext)({});

// src/components/use-suggestions.ts
function useSuggestions({
  type,
  property,
  term,
  disabled
}) {
  const { onAttributeChange } = (0, import_react6.useContext)(ConditionsContext);
  const [initialAttributeName] = (0, import_react6.useState)(property);
  const [initialTerm] = (0, import_react6.useState)(term);
  const hasChanged = property !== initialAttributeName || term !== initialTerm;
  const [suggestions, setSuggestions] = (0, import_react6.useState)([]);
  const [fetching, setFetching] = (0, import_react6.useState)(false);
  const debouncedTerm = useDebounce(term, 500);
  const shouldFetch = !disabled && (hasChanged || term === "");
  (0, import_react6.useEffect)(() => {
    (async () => {
      if (shouldFetch) {
        setFetching(true);
        setSuggestions(
          await (onAttributeChange == null ? void 0 : onAttributeChange(type, property, debouncedTerm))
        );
        setFetching(false);
      }
    })();
  }, [onAttributeChange, shouldFetch, property, debouncedTerm]);
  return [suggestions, fetching];
}

// src/components/PropertiesClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PAGE_KEY = "properties-clause";
var PropertiesClause = ({
  conditions,
  negated,
  propertiesClauseOperators = ALL_OPERATORS,
  onChange
}) => {
  if (negated) {
    throw new Error("Properties conditions cannot be negated");
  }
  const { properties: innerConditions } = conditions;
  const { property, operator, value } = innerConditions;
  const { propertyOptions } = (0, import_react7.useContext)(ConditionsContext);
  const [showOptions, toggleExpanded] = useStorageToggle(PAGE_KEY);
  const handleChange = (newInnerConditions) => onChange({ properties: newInnerConditions });
  const {
    draftValue,
    isRelativeTimeOperator,
    isAbsoluteTimeOperator,
    isNumericOperator,
    isDefaultOperator,
    isMultiValueOperator,
    onPropertyChange,
    onOperatorChange,
    onValueChange,
    onDateChange,
    onValueBlur,
    onValueSelected
  } = use_property_conditions_default(innerConditions, handleChange);
  const normalizedPropertyOptions = (0, import_react7.useMemo)(() => {
    const list = isGroupList(propertyOptions) ? propertyOptions.flatMap((group) => group.options) : propertyOptions;
    return Object.values(
      groupProfileAttributes(
        list.map((prop) => {
          return {
            value: prop.value,
            label: prop.value === prop.label ? getPropertyDisplayName(prop.value) : prop.label
          };
        })
      )
    );
  }, [propertyOptions]);
  const options = (0, import_react7.useMemo)(() => {
    const isKnowProperty = normalizedPropertyOptions == null ? void 0 : normalizedPropertyOptions.some((option) => {
      return option.options.some((subOption) => subOption.value === property);
    });
    if (isKnowProperty) {
      return normalizedPropertyOptions;
    }
    return [
      ...normalizedPropertyOptions,
      {
        label: "Unrecognized",
        options: [
          {
            label: getPropertyDisplayName(property),
            value: property
          }
        ]
      }
    ];
  }, [normalizedPropertyOptions, property]);
  const selectedPropertyOption = (0, import_react7.useMemo)(() => {
    if (!property) {
      return null;
    }
    return options.flatMap((group) => group.options).find((option) => option.value === property);
  }, [options, property]);
  const [suggestions, fetching] = useSuggestions({
    type: "USER",
    property,
    term: draftValue,
    disabled: !property || !isDefaultOperator
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Select, {
            name: "property",
            value: selectedPropertyOption,
            options,
            onChange: onPropertyChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Select, {
            name: "operator",
            value: propertiesClauseOperators == null ? void 0 : propertiesClauseOperators.find(
              ({ value: op }) => op === operator
            ),
            options: propertiesClauseOperators,
            onChange: onOperatorChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          isRelativeTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Input, {
                type: "number",
                "aria-label": "value",
                name: "value",
                value: draftValue,
                onChange: onValueChange,
                onBlur: onValueBlur
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
                children: [
                  draftValue === 1 ? "day" : "days",
                  ["> ago", "< ago"].includes(operator) && " ago"
                ]
              })
            ]
          }),
          isAbsoluteTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.DateInput, {
            portal: true,
            placement: "top",
            future: true,
            value: value ? new Date(Number(value)) : Date.now(),
            onChange: onDateChange
          }),
          isNumericOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.Input, {
            type: "number",
            "aria-label": "value",
            name: "value",
            value: draftValue,
            onChange: onValueChange,
            onBlur: onValueBlur
          }),
          isDefaultOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.DataList, {
            "aria-label": "value",
            name: "value",
            value: draftValue,
            suggestions,
            loading: fetching,
            onBlur: onValueBlur,
            onChange: onValueChange,
            onSelectedItemChange: onValueSelected
          }),
          isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components4.Button, {
            kind: "secondary",
            onClick: toggleExpanded,
            children: [
              showOptions ? "Hide" : "Show",
              " values"
            ]
          })
        ]
      }),
      showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components4.TextArea, {
        name: "value",
        "aria-label": "value",
        placeholder: "Enter values separated by commas or line breaks",
        value: draftValue,
        onChange: onValueChange,
        onBlur: onValueBlur
      })
    ]
  });
};

// src/components/GroupsClause.tsx
var import_react8 = require("react");
var import_legacy_components5 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var PAGE_KEY2 = "groups-clause";
var GroupsClause = ({ conditions, negated, onChange }) => {
  if (negated) {
    throw new Error("Groups conditions cannot be negated");
  }
  const { groups: innerConditions } = conditions;
  const { property, operator, value } = innerConditions;
  const { groupOptions } = (0, import_react8.useContext)(ConditionsContext);
  const [showOptions, toggleShowOptions] = useStorageToggle(PAGE_KEY2);
  const handleChange = (newInnerConditions) => onChange({ groups: newInnerConditions });
  const {
    draftValue,
    isRelativeTimeOperator,
    isAbsoluteTimeOperator,
    isNumericOperator,
    isDefaultOperator,
    isMultiValueOperator,
    onPropertyChange,
    onOperatorChange,
    onValueChange,
    onDateChange,
    onValueBlur,
    onValueSelected
  } = use_property_conditions_default(innerConditions, handleChange);
  const options = [...groupOptions];
  if (property && !options.some(
    ({ value: propertyName }) => propertyName === property
  )) {
    options.push({
      label: property,
      value: property
    });
  }
  const selectedPropertyOption = options.find(
    (option) => option.value === property
  );
  const selectedOperatorOption = ALL_OPERATORS.find(
    ({ value: op }) => op === operator
  );
  const [suggestions, fetching] = useSuggestions({
    type: "GROUP",
    property,
    term: draftValue,
    disabled: !property || !isDefaultOperator
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Select, {
            name: "property",
            value: selectedPropertyOption,
            options,
            onChange: onPropertyChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Select, {
            name: "operator",
            value: selectedOperatorOption,
            options: ALL_OPERATORS,
            onChange: onOperatorChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          isRelativeTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Input, {
                type: "number",
                "aria-label": "value",
                name: "value",
                value: draftValue,
                onChange: onValueChange,
                onBlur: onValueBlur
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", {
                children: [
                  draftValue === MILLISECONDS_PER_DAY ? "day" : "days",
                  ["> ago", "< ago"].includes(operator) && " ago"
                ]
              })
            ]
          }),
          isAbsoluteTimeOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.DateInput, {
            future: true,
            value: value ? new Date(value) : Date.now(),
            onChange: onDateChange
          }),
          isNumericOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.Input, {
            type: "number",
            "aria-label": "value",
            name: "value",
            value: draftValue,
            onChange: onValueChange,
            onBlur: onValueBlur
          }),
          isDefaultOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.DataList, {
            "aria-label": "value",
            name: "value",
            value: draftValue,
            suggestions,
            loading: fetching,
            onChange: onValueChange,
            onBlur: onValueBlur,
            onSelectedItemChange: onValueSelected
          }),
          isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components5.Button, {
            kind: "secondary",
            onClick: toggleShowOptions,
            children: [
              showOptions ? "Hide" : "Show",
              " values"
            ]
          })
        ]
      }),
      showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components5.TextArea, {
        name: "value",
        "aria-label": "value",
        placeholder: "Enter values separated by commas or line breaks",
        value: draftValue,
        onChange: onValueChange,
        onBlur: onValueBlur
      })
    ]
  });
};

// src/components/LanguagesClause.tsx
var import_react9 = require("react");
var import_legacy_components6 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS = [
  { label: "is", value: false },
  { label: "isn't", value: true }
];
var LanguagesClause = ({ conditions, negated, onChange }) => {
  const {
    languages: { value }
  } = conditions;
  const { languageOptions } = (0, import_react9.useContext)(ConditionsContext);
  const handleChange = (changes, nextNegated = negated) => {
    onChange(
      { languages: { ...conditions.languages, ...changes } },
      nextNegated
    );
  };
  const handleLocaleChange = ({ value: locale }) => handleChange({ value: locale });
  const handleNegatedChange = ({ value: nextNegated }) => handleChange({}, nextNegated);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components6.Select, {
        value: negated ? NEGATED_OPTIONS[1] : NEGATED_OPTIONS[0],
        options: NEGATED_OPTIONS,
        onChange: handleNegatedChange,
        portal: true,
        menuShouldBlockScroll: true
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components6.Select, {
        value: languageOptions.find(({ value: locale }) => locale === value),
        options: languageOptions,
        onChange: handleLocaleChange,
        portal: true,
        menuShouldBlockScroll: true
      })
    ]
  });
};

// src/components/ContentClause.tsx
var import_react11 = require("react");
var import_legacy_components8 = require("@studio/legacy-components");

// src/components/TimeframeOptions.tsx
var import_react10 = require("react");
var import_legacy_components7 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var OPERATOR_OPTIONS = [
  { label: "previously", value: "" },
  { label: "in the last", value: "< ago" },
  { label: "since", value: "since" }
];
var MILLISECONDS_PER_DAY2 = 24 * 60 * 60 * 1e3;
var TimeframeOptions = ({
  times = 1,
  operator = "",
  value,
  onChange
}) => {
  const timesRef = (0, import_react10.useRef)(null);
  const [relativeTimeValue, setRelativeTimeValue] = (0, import_react10.useState)(-1);
  (0, import_react10.useEffect)(() => {
    if (timesRef.current) {
      timesRef.current.value = String(times);
    }
  }, [times]);
  (0, import_react10.useEffect)(() => {
    if (operator === "< ago") {
      const numDays = value != null ? value : 1;
      setRelativeTimeValue(numDays / MILLISECONDS_PER_DAY2);
    }
  }, [operator, value]);
  const handleOperatorChange = ({
    value: newOperator
  }) => {
    if (newOperator === "< ago") {
      onChange({ operator: newOperator, value: MILLISECONDS_PER_DAY2 });
    } else if (newOperator === "since") {
      onChange({ operator: newOperator, value: Date.now() });
    } else {
      onChange({ operator: newOperator, value: void 0 });
    }
  };
  const handleTimesBlur = ({
    target: { valueAsNumber: newValue }
  }) => {
    let nextValue = newValue;
    if (!nextValue) {
      nextValue = 1;
      if (timesRef.current) {
        timesRef.current.value = String(nextValue);
      }
    }
    onChange({
      times: nextValue
    });
  };
  const handleRelativeTimeChange = ({
    target: { valueAsNumber }
  }) => void setRelativeTimeValue(valueAsNumber);
  const handleRelativeTimeBlur = ({
    target: { valueAsNumber }
  }) => {
    let nextValue = valueAsNumber;
    if (!nextValue) {
      nextValue = 1;
      setRelativeTimeValue(nextValue);
    }
    onChange({
      value: nextValue * MILLISECONDS_PER_DAY2
    });
  };
  const handleDateChange = (date) => void onChange({
    value: (0, import_legacy_components7.startOf)(date, "day").valueOf()
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TimeframeWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
        children: "At least"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Input, {
        type: "number",
        name: "times",
        "aria-label": "times",
        ref: timesRef,
        defaultValue: times,
        onBlur: handleTimesBlur
      }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
        children: times === 1 ? "time" : "times"
      }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Select, {
        name: "operator",
        value: OPERATOR_OPTIONS.find(
          ({ value: optionOperator }) => optionOperator === operator
        ),
        options: OPERATOR_OPTIONS,
        onChange: handleOperatorChange,
        portal: true
      }),
      operator === "< ago" && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.Input, {
            type: "number",
            name: "value",
            "aria-label": "value",
            value: relativeTimeValue,
            onChange: handleRelativeTimeChange,
            onBlur: handleRelativeTimeBlur
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
            children: relativeTimeValue === 1 ? "day" : "days"
          })
        ]
      }),
      operator === "since" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components7.DateInput, {
        future: true,
        name: "since",
        label: "since",
        value: value ? new Date(value) : new Date(),
        onChange: handleDateChange,
        placement: "top",
        portal: true
      })
    ]
  });
};

// src/components/ContentClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PAGE_KEY3 = "content-clause";
var ContentClause = ({ conditions, negated, onChange }) => {
  const [showOptions, toggleShowOptions] = useStorageToggle(PAGE_KEY3);
  const {
    content: { content, operator, times = 1, value = 1 }
  } = conditions;
  const { flowOptions } = (0, import_react11.useContext)(ConditionsContext);
  const handleChange = (changes, nextNegated = negated) => {
    onChange({ content: { ...conditions.content, ...changes } }, nextNegated);
  };
  const handleContentChange = ({ value: newContent }) => handleChange({ content: newContent });
  const handleNegationChange = ({
    value: nextNegated
  }) => handleChange({}, nextNegated);
  const stepGroupOptions = [...flowOptions];
  if (content && !stepGroupOptions.some(({ value: contentId }) => contentId === content)) {
    stepGroupOptions.push({ label: content, value: content });
  }
  const selectedStep = stepGroupOptions.find(
    ({ value: optionContent }) => optionContent === content
  );
  let event = "seen";
  if (selectedStep && selectedStep.stepType && ["tooltip-group", "hotspot-group"].includes(selectedStep.stepType)) {
    event = "completed";
  }
  const negatedOptions = [
    { label: `has been ${event}`, value: false },
    { label: `has not been ${event}`, value: true }
  ];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components8.Select, {
            value: selectedStep,
            options: stepGroupOptions,
            onChange: handleContentChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components8.Select, {
            value: negated ? negatedOptions[1] : negatedOptions[0],
            options: negatedOptions,
            onChange: handleNegationChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components8.Button, {
            kind: "secondary",
            onClick: toggleShowOptions,
            children: [
              showOptions ? "Hide" : "Show",
              " options"
            ]
          })
        ]
      }),
      showOptions && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TimeframeOptions, {
        times,
        operator,
        value,
        onChange: handleChange
      })
    ]
  });
};

// src/components/MobileContentClause.tsx
var import_react12 = require("react");
var import_legacy_components9 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SEEN_EVENT_OPTIONS = [
  {
    label: "has been seen",
    value: "has been seen",
    negation: false
  },
  {
    label: "has not been seen",
    value: "has not been seen",
    negation: true
  }
];
var COMPLETED_EVENT_OPTIONS = [
  {
    label: "has been completed",
    value: "has been completed",
    operator_attribute: "state",
    operator: OPERATORS.EQUALS,
    state: "completed",
    negation: false
  },
  {
    label: "has not been completed",
    value: "has not been completed",
    operator_attribute: "state",
    state: "completed",
    operator: OPERATORS.DOESNT_EQUAL,
    negation: false
  }
];
var MobileContentClause = ({
  conditions,
  negated,
  onChange
}) => {
  const {
    experience: { experience, operator, value }
  } = conditions;
  const { mobileFlowOptions } = (0, import_react12.useContext)(ConditionsContext);
  const selectedEvent = (0, import_react12.useMemo)(() => {
    return operator && value ? COMPLETED_EVENT_OPTIONS.find(
      (event) => event.state === value && event.operator.value === operator
    ) : SEEN_EVENT_OPTIONS.find((event) => event.negation === negated);
  }, [value, operator, negated]);
  const handleChange = (changes, nextNegated = negated) => {
    onChange(
      { experience: { ...conditions.experience, ...changes } },
      nextNegated
    );
  };
  const handleExperienceChange = ({
    value: newExperience
  }) => handleChange({ experience: newExperience });
  const handleStatusChange = ({
    negation,
    state,
    operator: eventOperator,
    operator_attribute: operatorAttribute
  }) => {
    const { experience: experienceCondition } = conditions;
    if (!state)
      delete experienceCondition.value;
    if (!eventOperator)
      delete experienceCondition.operator;
    if (!operatorAttribute)
      delete experienceCondition.operator_attribute;
    onChange(
      {
        experience: {
          ...experienceCondition,
          ...state && { value: state },
          ...eventOperator && { operator: eventOperator.value },
          ...operatorAttribute && { operator_attribute: operatorAttribute }
        }
      },
      negation
    );
  };
  const options = [...mobileFlowOptions];
  if (experience && !options.some(({ value: experienceId }) => experienceId === experience)) {
    options.push({ label: experience, value: experience });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components9.Select, {
          value: options.find(
            ({ value: optionExperience }) => optionExperience === experience
          ),
          options,
          onChange: handleExperienceChange,
          portal: true,
          menuShouldBlockScroll: true
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components9.Select, {
          value: selectedEvent,
          options: [...SEEN_EVENT_OPTIONS, ...COMPLETED_EVENT_OPTIONS],
          onChange: handleStatusChange,
          portal: true,
          menuShouldBlockScroll: true
        })
      ]
    })
  });
};

// src/components/EventClause.tsx
var import_react13 = require("react");
var import_legacy_components10 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS2 = [
  { label: "has occurred", value: false },
  { label: "has not occurred", value: true }
];
function formatEventName(event) {
  return event.replace("appcues_custom:", "");
}
var PAGE_KEY4 = "event-clause";
var EventClause = ({ conditions, negated, onChange }) => {
  const [showOptions, toggleShowOptions] = useStorageToggle(PAGE_KEY4);
  const {
    event: { event, operator, times = 1, value = 1 }
  } = conditions;
  const { eventOptions } = (0, import_react13.useContext)(ConditionsContext);
  const handleChange = (changes, nextNegated = negated) => {
    onChange({ event: { ...conditions.event, ...changes } }, nextNegated);
  };
  const handleEventChange = ({ value: newEvent }) => handleChange({ event: newEvent });
  const handleNegatedChange = ({ value: nextNegated }) => handleChange({}, nextNegated);
  const options = (0, import_react13.useMemo)(() => {
    const isKnownEvent = eventOptions.some(
      ({ value: optionEvent }) => optionEvent === event
    );
    const normalizedEventOptions = eventOptions.map((option) => {
      return { ...option, label: formatEventName(option.label) };
    });
    if (event && !isKnownEvent) {
      normalizedEventOptions.push({
        label: formatEventName(event),
        value: event
      });
    }
    return normalizedEventOptions;
  }, [event, eventOptions]);
  const selectedEvent = (0, import_react13.useMemo)(() => {
    return options.find(({ value: optionEvent }) => optionEvent === event);
  }, [event, options]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ClauseWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components10.Select, {
            value: selectedEvent,
            options,
            onChange: handleEventChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components10.Select, {
            value: negated ? NEGATED_OPTIONS2[1] : NEGATED_OPTIONS2[0],
            options: NEGATED_OPTIONS2,
            onChange: handleNegatedChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components10.Button, {
            kind: "secondary",
            onClick: toggleShowOptions,
            children: [
              showOptions ? "Hide" : "Show",
              " options"
            ]
          })
        ]
      }),
      showOptions && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TimeframeOptions, {
        times,
        operator,
        value,
        onChange: handleChange
      })
    ]
  });
};

// src/components/SegmentsClause.tsx
var import_react14 = require("react");
var import_legacy_components11 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS3 = [
  { label: "matches", value: false },
  { label: "doesn't match", value: true }
];
var SegmentsClause = ({ conditions, negated, onChange }) => {
  const {
    segments: { segment }
  } = conditions;
  const { segmentOptions } = (0, import_react14.useContext)(ConditionsContext);
  const handleChange = (changes, nextNegated = negated) => {
    onChange({ segments: { ...conditions.segments, ...changes } }, nextNegated);
  };
  const handleSegmentChange = ({ value: newSegment }) => handleChange({ segment: newSegment });
  const handleNegatedChange = ({ value: nextNegated }) => handleChange({}, nextNegated);
  const options = [...segmentOptions];
  if (segment && !options.some(({ value: segmentId }) => segmentId === segment)) {
    options.push({ label: segment, value: segment });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components11.Select, {
        value: options.find(
          ({ value: optionSegment }) => optionSegment === segment
        ),
        options,
        onChange: handleSegmentChange,
        portal: true,
        menuShouldBlockScroll: true
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components11.Select, {
        value: negated ? NEGATED_OPTIONS3[1] : NEGATED_OPTIONS3[0],
        options: NEGATED_OPTIONS3,
        onChange: handleNegatedChange,
        portal: true,
        menuShouldBlockScroll: true
      })
    ]
  });
};

// src/components/ChecklistsClause.tsx
var import_react15 = require("react");
var import_legacy_components12 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var STATUS_OPTIONS = [
  { label: "is in progress", value: "in_progress" },
  { label: "has been skipped", value: "skipped" },
  { label: "has been completed", value: "completed\ndismissed" },
  {
    label: "has not been seen",
    value: null
  }
];
var ChecklistsClause = ({ conditions, negated, onChange }) => {
  if (negated) {
    throw new Error("Checklists conditions cannot be negated");
  }
  const {
    checklists: { checklist, status = null }
  } = conditions;
  const { checklistOptions } = (0, import_react15.useContext)(ConditionsContext);
  const handleChange = (changes) => {
    onChange({ checklists: { ...conditions.checklists, ...changes } });
  };
  const handleChecklistChange = ({
    value: newChecklist
  }) => handleChange({ checklist: newChecklist });
  const handleStatusChange = ({
    value: newStatus
  }) => {
    handleChange({ status: newStatus });
  };
  const options = [...checklistOptions];
  if (checklist && !checklistOptions.some(
    ({ value: checklistId }) => checklistId === checklist
  )) {
    options.push({ label: checklist, value: checklist });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components12.Select, {
        value: options.find(({ value }) => value === checklist),
        options,
        onChange: handleChecklistChange,
        portal: true,
        menuShouldBlockScroll: true
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components12.Select, {
        value: STATUS_OPTIONS.find(({ value }) => value === status),
        options: STATUS_OPTIONS,
        onChange: handleStatusChange,
        portal: true,
        menuShouldBlockScroll: true
      })
    ]
  });
};

// src/components/ScreenClause.tsx
var import_react16 = require("react");
var import_legacy_components13 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SCREEN_OPERATORS = [
  OPERATORS.STARTS_WITH,
  OPERATORS.DOESNT_START_WITH,
  OPERATORS.ENDS_WITH,
  OPERATORS.DOESNT_END_WITH,
  OPERATORS.CONTAINS,
  OPERATORS.DOESNT_CONTAIN,
  OPERATORS.EQUALS,
  OPERATORS.DOESNT_EQUAL,
  OPERATORS.MATCHES_REGEX
];
var ScreenClause = ({ conditions, onChange }) => {
  const valueRef = (0, import_react16.useRef)();
  const {
    screen: { operator: currentOperator, value: currentValue = "" }
  } = conditions;
  (0, import_react16.useEffect)(() => {
    if (valueRef.current) {
      valueRef.current.value = currentValue;
    }
  }, [currentValue]);
  const handleChange = (changes) => void onChange({
    screen: { ...conditions.screen, ...changes }
  });
  const handleOperatorChange = ({
    value: operator
  }) => void handleChange({ operator });
  const handleValueBlur = ({
    target: { value }
  }) => void handleChange({ value });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components13.Select, {
        name: "operator",
        value: SCREEN_OPERATORS.find(({ value }) => value === currentOperator),
        options: SCREEN_OPERATORS,
        onChange: handleOperatorChange,
        portal: true,
        menuShouldBlockScroll: true
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components13.Input, {
        type: "text",
        "aria-label": "value",
        name: "value",
        ref: valueRef,
        defaultValue: currentValue,
        placeholder: "e.g. account:home",
        onBlur: handleValueBlur
      })
    ]
  });
};

// src/components/VersionClause.tsx
var import_react17 = require("react");
var import_legacy_components14 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var VERSION_OPERATORS = [
  OPERATORS.EQUALS,
  OPERATORS.IS_LESS_THAN,
  OPERATORS.IS_LESS_OR_EQUAL,
  OPERATORS.IS_GREATER_THAN,
  OPERATORS.IS_GREATER_OR_EQUAL
];
function semverRegex() {
  return /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/gi;
}
var VersionClause = ({ conditions, onChange }) => {
  const valueRef = (0, import_react17.useRef)(null);
  const {
    version: { operator: currentOperator, value: currentValue = "" }
  } = conditions;
  const isValidSemver = currentValue ? semverRegex().test(currentValue) : true;
  (0, import_react17.useEffect)(() => {
    if (valueRef.current) {
      valueRef.current.value = currentValue;
    }
  }, [currentValue]);
  const handleChange = (changes) => void onChange({
    version: { ...conditions.version, ...changes }
  });
  const handleOperatorChange = ({
    value: operator
  }) => void handleChange({ operator });
  const handleValueBlur = ({
    target: { value }
  }) => void handleChange({ value });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(VersionClauseWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.Select, {
            name: "operator",
            value: VERSION_OPERATORS.find(
              ({ value }) => value === currentOperator
            ),
            options: VERSION_OPERATORS,
            onChange: handleOperatorChange,
            portal: true,
            menuShouldBlockScroll: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.Input, {
            type: "text",
            "aria-label": "value",
            name: "value",
            ref: valueRef,
            defaultValue: currentValue,
            placeholder: "e.g. 1.0.0",
            onBlur: handleValueBlur
          })
        ]
      }),
      !isValidSemver && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components14.WarningNotice, {
        children: "The version format should follow semantic versioning: major.minor.patch, or 1.10.0 for example. This Flow may not be shown to users."
      })
    ]
  });
};

// src/components/AttributesClause.tsx
var import_react19 = require("react");
var import_legacy_components16 = require("@studio/legacy-components");

// src/components/PropertyTextArea.tsx
var import_react18 = require("react");
var import_styled_components2 = __toESM(require("styled-components"));
var import_legacy_components15 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var Wrapper2 = import_styled_components2.default.div`
  ${import_legacy_components15.NegativeNotice} {
    margin-bottom: 10px;
  }

  ${import_legacy_components15.TextArea} {
    width: 100%;
  }
`;
var PropertyTextArea = ({ defaultValue, onChange, onBlur }) => {
  const [isErrored, setIsErrored] = (0, import_react18.useState)(false);
  const [value, setValue] = (0, import_react18.useState)(defaultValue);
  const numValues = (0, import_react18.useMemo)(() => {
    var _a;
    return (_a = String(value)) == null ? void 0 : _a.split("\n").length;
  }, [value]);
  const handleChange = (event) => {
    const {
      target: { value: nextValue }
    } = event;
    const values = nextValue.replace(/(\s*,\s*)|\n/g, ",\n").replace(/\s*,\s*/g, ",").replace(/(^[\t ]*\n*\s+$)/gm, "").split(",");
    const trimmed = values.slice(0, 1e3).join("\n");
    setValue(trimmed);
    setIsErrored(values.length > 1e3);
    event.target.value = trimmed;
    onChange(event);
  };
  const handleErrorDismissed = () => setIsErrored(false);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper2, {
    children: [
      isErrored && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components15.NegativeNotice, {
        onDismiss: handleErrorDismissed,
        children: "Only the maximum 1,000 values will be saved."
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components15.TextArea, {
        resize: true,
        name: "value",
        "aria-label": "value",
        value,
        placeholder: "Enter values separated by commas or line breaks",
        onChange: handleChange,
        onBlur
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
        children: `${numValues}/1000`
      })
    ]
  });
};
var PropertyTextArea_default = PropertyTextArea;

// src/components/AttributesClause.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ATTRIBUTES_OPERATORS = [
  OPERATORS.EQUALS,
  OPERATORS.DOESNT_EQUAL,
  OPERATORS.CONTAINS,
  OPERATORS.DOESNT_CONTAIN,
  OPERATORS.STARTS_WITH,
  OPERATORS.DOESNT_START_WITH,
  OPERATORS.ENDS_WITH,
  OPERATORS.DOESNT_END_WITH,
  OPERATORS.EXISTS,
  OPERATORS.DOESNT_EXIST,
  OPERATORS.IS_ONE_OF,
  OPERATORS.ISNT_ONE_OF,
  OPERATORS.IS_GREATER_THAN,
  OPERATORS.IS_LESS_THAN,
  OPERATORS.MATCHES_REGEX
];
var ATTRIBUTES_KEY = "attributes";
var checkMultiValueOperator = (value) => [OPERATORS.IS_ONE_OF.value, OPERATORS.ISNT_ONE_OF.value].includes(value);
function AttributesClause({ conditions, onChange }) {
  const attributeRef = (0, import_react19.useRef)();
  const valueRef = (0, import_react19.useRef)();
  const [showOptions, toggleExpanded] = (0, import_react19.useState)(false);
  const [multiValue, setMultiValue] = (0, import_react19.useState)("");
  const {
    [ATTRIBUTES_KEY]: {
      attribute: currentAttribute = "",
      operator: currentOperator,
      value: currentValue = ""
    }
  } = conditions;
  const handleChange = (changes) => void onChange({
    [ATTRIBUTES_KEY]: { ...conditions[ATTRIBUTES_KEY], ...changes }
  });
  const handleToggle = () => {
    toggleExpanded((val) => !val);
  };
  const handleOperatorChange = ({
    value: operator
  }) => {
    void handleChange({ operator });
    if (checkMultiValueOperator(operator)) {
      toggleExpanded(true);
    }
  };
  const handleMultiValueInputBlur = ({
    target: { value }
  }) => {
    void handleChange({ value });
  };
  const valueCounter = () => {
    const values = multiValue != null ? multiValue : currentValue;
    return (values == null ? void 0 : values.length) > 0 ? values == null ? void 0 : values.split("\n").length : -1;
  };
  const handleMultiValueInputChange = ({
    target: { value }
  }) => {
    setMultiValue(value);
  };
  const handleInputBlur = (name) => ({ target: { value } }) => void handleChange({ [name]: value });
  const isMultiValueOperator = checkMultiValueOperator(currentOperator);
  const multiValueCounter = valueCounter();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Input, {
            name: "attribute",
            "aria-label": "attribute",
            type: "text",
            ref: attributeRef,
            defaultValue: currentAttribute,
            placeholder: "Enter attribute",
            onBlur: handleInputBlur("attribute")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Select, {
            name: "operator",
            value: ATTRIBUTES_OPERATORS.find(
              ({ value }) => value === currentOperator
            ),
            options: ATTRIBUTES_OPERATORS,
            onChange: handleOperatorChange,
            menuShouldBlockScroll: true,
            portal: true
          }),
          !isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components16.Input, {
            name: "value",
            "aria-label": "value",
            type: "text",
            ref: valueRef,
            defaultValue: currentValue,
            placeholder: "Enter attribute value",
            onBlur: handleInputBlur("value")
          }),
          isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ToggleButton, {
            kind: "secondary",
            onClick: handleToggle,
            children: [
              showOptions ? "Hide" : "Show",
              " ",
              multiValueCounter,
              " value",
              multiValueCounter > 1 ? "s" : ""
            ]
          })
        ]
      }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextAreaWrapper, {
        children: showOptions && isMultiValueOperator && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PropertyTextArea_default, {
          defaultValue: currentValue,
          onBlur: handleMultiValueInputBlur,
          onChange: handleMultiValueInputChange
        })
      })
    ]
  });
}

// src/components/PinsClause.tsx
var import_react20 = require("react");
var import_legacy_components17 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var NEGATED_OPTIONS4 = [
  { label: "has been interacted with", value: false },
  { label: "has not been interacted with", value: true }
];
var PinsClause = ({ conditions, negated, onChange }) => {
  const {
    experienceStep: { experienceStep }
  } = conditions;
  const { pinOptions } = (0, import_react20.useContext)(ConditionsContext);
  const handleChange = (changes, nextNegated = negated) => {
    const experienceStepCondition = { ...conditions.experienceStep };
    if (!changes.interaction)
      delete experienceStepCondition.interaction;
    onChange(
      {
        experienceStep: {
          ...experienceStepCondition,
          ...changes
        }
      },
      nextNegated
    );
  };
  const handlePinChange = ({ value: newPin }) => {
    var _a;
    const type = (_a = pinOptions.find((pin) => pin.value === newPin)) == null ? void 0 : _a.type;
    handleChange({
      experienceStep: newPin,
      ...type === "button" && { interaction: "Button Pin Clicked" }
    });
  };
  const handleNegatedChange = ({ value: nextNegated }) => handleChange({}, nextNegated);
  const options = [...pinOptions];
  if (experienceStep && !pinOptions.some(({ value: pinId }) => pinId === experienceStep)) {
    options.push({ label: experienceStep, value: experienceStep });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components17.Select, {
          value: options.find(
            ({ value: experienceValue }) => experienceValue === experienceStep
          ),
          options,
          onChange: handlePinChange,
          portal: true,
          menuShouldBlockScroll: true
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components17.Select, {
          value: negated ? NEGATED_OPTIONS4[1] : NEGATED_OPTIONS4[0],
          options: NEGATED_OPTIONS4,
          onChange: handleNegatedChange,
          portal: true,
          menuShouldBlockScroll: true
        })
      ]
    })
  });
};

// src/components/get-empty-clause.ts
var getEmptyClause = (type, subConditionType) => {
  switch (type) {
    case "app":
      return { app: { operator: "==", value: "" } };
    case "attributes":
      return { attributes: { attribute: "", operator: "==", value: "" } };
    case "checklists":
      return { checklists: { checklist: "", status: "completed\ndismissed" } };
    case "content":
      return { content: { content: "" } };
    case "domains":
      return { domains: { operator: "==", value: "" } };
    case "event":
      return { event: { event: "" } };
    case "experience":
      return { experience: { type: "mobile", experience: "" } };
    case "experienceStep":
      return {
        experienceStep: {
          type: subConditionType,
          experienceStep: ""
        }
      };
    case "groups":
      return { groups: { property: "", operator: "*", value: "" } };
    case "languages":
      return { languages: { operator: "^", value: "en-us" } };
    case "properties":
      return { properties: { property: "", operator: "*", value: "" } };
    case "screen":
      return { screen: { operator: "*", value: "" } };
    case "segments":
      return { segments: { segment: "" } };
    case "trigger":
      return { trigger: { event: "" } };
    case "url":
      return { url: { operator: "^", value: "" } };
    case "version":
    default:
      return { version: { operator: "==", value: "" } };
  }
};

// src/components/helpers.js
var import_fuzzyurl = __toESM(require("fuzzyurl"));

// src/components/constants/language.js
var LANGUAGE_OPTIONS = [
  {
    label: "Abkhaz",
    value: "ab"
  },
  {
    label: "Afar",
    value: "aa"
  },
  {
    label: "Afrikaans",
    value: "af"
  },
  {
    label: "Akan",
    value: "ak"
  },
  {
    label: "Albanian",
    value: "sq"
  },
  {
    label: "Amharic",
    value: "am"
  },
  {
    label: "Arabic",
    value: "ar"
  },
  {
    label: "Arabic - Algeria",
    value: "ar-dz"
  },
  {
    label: "Arabic - Bahrain",
    value: "ar-bh"
  },
  {
    label: "Arabic - Egypt",
    value: "ar-eg"
  },
  {
    label: "Arabic - Iraq",
    value: "ar-iq"
  },
  {
    label: "Arabic - Jordan",
    value: "ar-jo"
  },
  {
    label: "Arabic - Kuwait",
    value: "ar-kw"
  },
  {
    label: "Arabic - Lebanon",
    value: "ar-lb"
  },
  {
    label: "Arabic - Libya",
    value: "ar-ly"
  },
  {
    label: "Arabic - Morocco",
    value: "ar-ma"
  },
  {
    label: "Arabic - Oman",
    value: "ar-om"
  },
  {
    label: "Arabic - Qatar",
    value: "ar-qa"
  },
  {
    label: "Arabic - Saudi Arabia",
    value: "ar-sa"
  },
  {
    label: "Arabic - Syria",
    value: "ar-sy"
  },
  {
    label: "Arabic - Tunisia",
    value: "ar-tn"
  },
  {
    label: "Arabic - United Arab Emirates",
    value: "ar-ae"
  },
  {
    label: "Arabic - Yemen",
    value: "ar-ye"
  },
  {
    label: "Aragonese",
    value: "an"
  },
  {
    label: "Armenian",
    value: "hy"
  },
  {
    label: "Assamese",
    value: "as"
  },
  {
    label: "Avaric",
    value: "av"
  },
  {
    label: "Avestan",
    value: "ae"
  },
  {
    label: "Aymara",
    value: "ay"
  },
  {
    label: "Azerbaijani",
    value: "az"
  },
  {
    label: "Azeri - Cyrillic",
    value: "az-az"
  },
  {
    label: "Azeri - Latin",
    value: "az-az"
  },
  {
    label: "Bambara",
    value: "bm"
  },
  {
    label: "Bashkir",
    value: "ba"
  },
  {
    label: "Basque",
    value: "eu"
  },
  {
    label: "Belarusian",
    value: "be"
  },
  {
    label: "Bengali, Bangla",
    value: "bn"
  },
  {
    label: "Bihari",
    value: "bh"
  },
  {
    label: "Bislama",
    value: "bi"
  },
  {
    label: "Bosnian",
    value: "bs"
  },
  {
    label: "Breton",
    value: "br"
  },
  {
    label: "Bulgarian",
    value: "bg"
  },
  {
    label: "Burmese",
    value: "my"
  },
  {
    label: "Catalan",
    value: "ca"
  },
  {
    label: "Chamorro",
    value: "ch"
  },
  {
    label: "Chechen",
    value: "ce"
  },
  {
    label: "Chichewa, Chewa, Nyanja",
    value: "ny"
  },
  {
    label: "Chinese",
    value: "zh"
  },
  {
    label: "Chinese - China",
    value: "zh-cn"
  },
  {
    label: "Chinese - Hong Kong SAR",
    value: "zh-hk"
  },
  {
    label: "Chinese - Macau SAR",
    value: "zh-mo"
  },
  {
    label: "Chinese - Singapore",
    value: "zh-sg"
  },
  {
    label: "Chinese - Taiwan",
    value: "zh-tw"
  },
  {
    label: "Chinese (Simplified)",
    value: "zh-hans"
  },
  {
    label: "Chinese (Simplified) - China",
    value: "zh-hans-cn"
  },
  {
    label: "Chinese (Simplified) - Hong Kong SAR",
    value: "zh-hans-hk"
  },
  {
    label: "Chinese (Simplified) - Macao SAR",
    value: "zh-hans-mo"
  },
  {
    label: "Chinese (Simplified) - Singapore",
    value: "zh-hans-sg"
  },
  {
    label: "Chinese (Traditional)",
    value: "zh-hant"
  },
  {
    label: "Chinese (Traditional) - Hong Kong SAR",
    value: "zh-hant-hk"
  },
  {
    label: "Chinese (Traditional) - Macao SAR",
    value: "zh-hant-mo"
  },
  {
    label: "Chinese (Traditional) - Taiwan",
    value: "zh-hant-tw"
  },
  {
    label: "Chuvash",
    value: "cv"
  },
  {
    label: "Cornish",
    value: "kw"
  },
  {
    label: "Corsican",
    value: "co"
  },
  {
    label: "Cree",
    value: "cr"
  },
  {
    label: "Croatian",
    value: "hr"
  },
  {
    label: "Czech",
    value: "cs"
  },
  {
    label: "Danish",
    value: "da"
  },
  {
    label: "Divehi, Dhivehi, Maldivian",
    value: "dv"
  },
  {
    label: "Dutch",
    value: "nl"
  },
  {
    label: "Dutch - Belgium",
    value: "nl-be"
  },
  {
    label: "Dutch - Netherlands",
    value: "nl-nl"
  },
  {
    label: "Dzongkha",
    value: "dz"
  },
  {
    label: "English",
    value: "en"
  },
  {
    label: "English - Australia",
    value: "en-au"
  },
  {
    label: "English - Belize",
    value: "en-bz"
  },
  {
    label: "English - Canada",
    value: "en-ca"
  },
  {
    label: "English - Caribbean",
    value: "en-cb"
  },
  {
    label: "English - Great Britain",
    value: "en-gb"
  },
  {
    label: "English - India",
    value: "en-in"
  },
  {
    label: "English - Ireland",
    value: "en-ie"
  },
  {
    label: "English - Jamaica",
    value: "en-jm"
  },
  {
    label: "English - New Zealand",
    value: "en-nz"
  },
  {
    label: "English - Phillippines",
    value: "en-ph"
  },
  {
    label: "English - Southern Africa",
    value: "en-za"
  },
  {
    label: "English - Trinidad",
    value: "en-tt"
  },
  {
    label: "English - United States",
    value: "en-us"
  },
  {
    label: "Esperanto",
    value: "eo"
  },
  {
    label: "Estonian",
    value: "et"
  },
  {
    label: "Ewe",
    value: "ee"
  },
  {
    label: "Faroese",
    value: "fo"
  },
  {
    label: "Fijian",
    value: "fj"
  },
  {
    label: "Finnish",
    value: "fi"
  },
  {
    label: "French",
    value: "fr"
  },
  {
    label: "French - Belgium",
    value: "fr-be"
  },
  {
    label: "French - Canada",
    value: "fr-ca"
  },
  {
    label: "French - France",
    value: "fr-fr"
  },
  {
    label: "French - Luxembourg",
    value: "fr-lu"
  },
  {
    label: "French - Switzerland",
    value: "fr-ch"
  },
  {
    label: "Fula, Fulah, Pulaar, Pular",
    value: "ff"
  },
  {
    label: "Galician",
    value: "gl"
  },
  {
    label: "Gaelic - Ireland",
    value: "gd-ie"
  },
  {
    label: "Ganda",
    value: "lg"
  },
  {
    label: "Georgian",
    value: "ka"
  },
  {
    label: "German",
    value: "de"
  },
  {
    label: "German - Austria",
    value: "de-at"
  },
  {
    label: "German - Germany",
    value: "de-de"
  },
  {
    label: "German - Liechtenstein",
    value: "de-li"
  },
  {
    label: "German - Luxembourg",
    value: "de-lu"
  },
  {
    label: "German - Switzerland",
    value: "de-ch"
  },
  {
    label: "Greek (modern)",
    value: "el"
  },
  {
    label: "Guaran\xED",
    value: "gn"
  },
  {
    label: "Gujarati",
    value: "gu"
  },
  {
    label: "Haitian, Haitian Creole",
    value: "ht"
  },
  {
    label: "Hausa",
    value: "ha"
  },
  {
    label: "Hebrew (modern)",
    value: "he"
  },
  {
    label: "Herero",
    value: "hz"
  },
  {
    label: "Hindi",
    value: "hi"
  },
  {
    label: "Hiri Motu",
    value: "ho"
  },
  {
    label: "Hungarian",
    value: "hu"
  },
  {
    label: "Icelandic",
    value: "is"
  },
  {
    label: "Ido",
    value: "io"
  },
  {
    label: "Igbo",
    value: "ig"
  },
  {
    label: "Indonesian",
    value: "id"
  },
  {
    label: "Interlingua",
    value: "ia"
  },
  {
    label: "Interlingue",
    value: "ie"
  },
  {
    label: "Inuktitut",
    value: "iu"
  },
  {
    label: "Inupiaq",
    value: "ik"
  },
  {
    label: "Irish",
    value: "ga"
  },
  {
    label: "Italian",
    value: "it"
  },
  {
    label: "Italian - Italy",
    value: "it-it"
  },
  {
    label: "Italian - Switzerland",
    value: "it-ch"
  },
  {
    label: "Japanese",
    value: "ja"
  },
  {
    label: "Javanese",
    value: "jv"
  },
  {
    label: "Kalaallisut, Greenlandic",
    value: "kl"
  },
  {
    label: "Kannada",
    value: "kn"
  },
  {
    label: "Kanuri",
    value: "kr"
  },
  {
    label: "Kashmiri",
    value: "ks"
  },
  {
    label: "Kazakh",
    value: "kk"
  },
  {
    label: "Khmer",
    value: "km"
  },
  {
    label: "Kikuyu, Gikuyu",
    value: "ki"
  },
  {
    label: "Kinyarwanda",
    value: "rw"
  },
  {
    label: "Kirundi",
    value: "rn"
  },
  {
    label: "Komi",
    value: "kv"
  },
  {
    label: "Kongo",
    value: "kg"
  },
  {
    label: "Korean",
    value: "ko"
  },
  {
    label: "Kurdish",
    value: "ku"
  },
  {
    label: "Kwanyama, Kuanyama",
    value: "kj"
  },
  {
    label: "Kyrgyz",
    value: "ky"
  },
  {
    label: "Lao",
    value: "lo"
  },
  {
    label: "Latin",
    value: "la"
  },
  {
    label: "Latvian",
    value: "lv"
  },
  {
    label: "Limburgish, Limburgan, Limburger",
    value: "li"
  },
  {
    label: "Lingala",
    value: "ln"
  },
  {
    label: "Lithuanian",
    value: "lt"
  },
  {
    label: "Luba-Katanga",
    value: "lu"
  },
  {
    label: "Luxembourgish, Letzeburgesch",
    value: "lb"
  },
  {
    label: "Macedonian",
    value: "mk"
  },
  {
    label: "Malagasy",
    value: "mg"
  },
  {
    label: "Malay",
    value: "ms"
  },
  {
    label: "Malay - Brunei",
    value: "ms-bn"
  },
  {
    label: "Malay - Malaysia",
    value: "ms-my"
  },
  {
    label: "Malayalam",
    value: "ml"
  },
  {
    label: "Maltese",
    value: "mt"
  },
  {
    label: "Manx",
    value: "gv"
  },
  {
    label: "Marathi (Mar\u0101\u1E6Dh\u012B)",
    value: "mr"
  },
  {
    label: "Marshallese",
    value: "mh"
  },
  {
    label: "Mongolian",
    value: "mn"
  },
  {
    label: "Montenegrin",
    value: "me"
  },
  {
    label: "M\u0101ori",
    value: "mi"
  },
  {
    label: "Nauruan",
    value: "na"
  },
  {
    label: "Navajo, Navaho",
    value: "nv"
  },
  {
    label: "Ndonga",
    value: "ng"
  },
  {
    label: "Nepali",
    value: "ne"
  },
  {
    label: "Northern Ndebele",
    value: "nd"
  },
  {
    label: "Northern Sami",
    value: "se"
  },
  {
    label: "Norwegian",
    value: "no"
  },
  {
    label: "Norwegian - Bokml",
    value: "no-no"
  },
  {
    label: "Norwegian - Nynorsk",
    value: "no-no"
  },
  {
    label: "Norwegian Bokm\xE5l",
    value: "nb"
  },
  {
    label: "Norwegian Nynorsk",
    value: "nn"
  },
  {
    label: "Nuosu",
    value: "ii"
  },
  {
    label: "Occitan",
    value: "oc"
  },
  {
    label: "Ojibwe, Ojibwa",
    value: "oj"
  },
  {
    label: "Old Church Slavonic, Church Slavonic,Old Bulgarian",
    value: "cu"
  },
  {
    label: "Oriya",
    value: "or"
  },
  {
    label: "Oromo",
    value: "om"
  },
  {
    label: "Ossetian, Ossetic",
    value: "os"
  },
  {
    label: "Panjabi, Punjabi",
    value: "pa"
  },
  {
    label: "Pashto, Pushto",
    value: "ps"
  },
  {
    label: "Persian (Farsi)",
    value: "fa"
  },
  {
    label: "Polish",
    value: "pl"
  },
  {
    label: "Portuguese",
    value: "pt"
  },
  {
    label: "Portuguese - Brazil",
    value: "pt-br"
  },
  {
    label: "Portuguese - Portugal",
    value: "pt-pt"
  },
  {
    label: "P\u0101li",
    value: "pi"
  },
  {
    label: "Quechua",
    value: "qu"
  },
  {
    label: "Romanian",
    value: "ro"
  },
  {
    label: "Romanian - Moldova",
    value: "ro-mo"
  },
  {
    label: "Romansh",
    value: "rm"
  },
  {
    label: "Russian",
    value: "ru"
  },
  {
    label: "Russian - Moldova",
    value: "ru-mo"
  },
  {
    label: "Samoan",
    value: "sm"
  },
  {
    label: "Sango",
    value: "sg"
  },
  {
    label: "Sanskrit (Sa\u1E41sk\u1E5Bta)",
    value: "sa"
  },
  {
    label: "Sardinian",
    value: "sc"
  },
  {
    label: "Scottish Gaelic, Gaelic",
    value: "gd"
  },
  {
    label: "Serbian",
    value: "sr"
  },
  {
    label: "Serbian (Cyrillic)",
    value: "sr-cyrl"
  },
  {
    label: "Serbian (Cyrillic) - Bosnia and Herzegovina",
    value: "sr-cyrl-ba"
  },
  {
    label: "Serbian (Cyrillic) - Montenegro",
    value: "sr-cyrl-me"
  },
  {
    label: "Serbian (Cyrillic-) - Serbia",
    value: "sr-cyrl-rs"
  },
  {
    label: "Serbian (Latin)",
    value: "sr-latn"
  },
  {
    label: "Serbian (Latin) - Bosnia and Herzegovina",
    value: "sr-latn-ba"
  },
  {
    label: "Serbian (Latin) - Montenegro",
    value: "sr-latn-me"
  },
  {
    label: "Serbian (Latin) - Serbia",
    value: "sr-latn-rs"
  },
  {
    label: "Shona",
    value: "sn"
  },
  {
    label: "Sindhi",
    value: "sd"
  },
  {
    label: "Sinhala, Sinhalese",
    value: "si"
  },
  {
    label: "Slovak",
    value: "sk"
  },
  {
    label: "Slovene",
    value: "sl"
  },
  {
    label: "Somali",
    value: "so"
  },
  {
    label: "Southern Ndebele",
    value: "nr"
  },
  {
    label: "Southern Sotho",
    value: "st"
  },
  {
    label: "Spanish",
    value: "es"
  },
  {
    label: "Spanish - Argentina",
    value: "es-ar"
  },
  {
    label: "Spanish - Bolivia",
    value: "es-bo"
  },
  {
    label: "Spanish - Chile",
    value: "es-cl"
  },
  {
    label: "Spanish - Colombia",
    value: "es-co"
  },
  {
    label: "Spanish - Costa Rica",
    value: "es-cr"
  },
  {
    label: "Spanish - Dominican Republic",
    value: "es-do"
  },
  {
    label: "Spanish - Ecuador",
    value: "es-ec"
  },
  {
    label: "Spanish - El Salvador",
    value: "es-sv"
  },
  {
    label: "Spanish - Guatemala",
    value: "es-gt"
  },
  {
    label: "Spanish - Honduras",
    value: "es-hn"
  },
  {
    label: "Spanish - Mexico",
    value: "es-mx"
  },
  {
    label: "Spanish - Nicaragua",
    value: "es-ni"
  },
  {
    label: "Spanish - Panama",
    value: "es-pa"
  },
  {
    label: "Spanish - Paraguay",
    value: "es-py"
  },
  {
    label: "Spanish - Peru",
    value: "es-pe"
  },
  {
    label: "Spanish - Puerto Rico",
    value: "es-pr"
  },
  {
    label: "Spanish - Spain (Traditional)",
    value: "es-es"
  },
  {
    label: "Spanish - Uruguay",
    value: "es-uy"
  },
  {
    label: "Spanish - Venezuela",
    value: "es-ve"
  },
  {
    label: "Sundanese",
    value: "su"
  },
  {
    label: "Swahili",
    value: "sw"
  },
  {
    label: "Swati",
    value: "ss"
  },
  {
    label: "Swedish",
    value: "sv"
  },
  {
    label: "Swedish - Finland",
    value: "sv-fi"
  },
  {
    label: "Swedish - Sweden",
    value: "sv-se"
  },
  {
    label: "Tagalog",
    value: "tl"
  },
  {
    label: "Tahitian",
    value: "ty"
  },
  {
    label: "Tajik",
    value: "tg"
  },
  {
    label: "Tamil",
    value: "ta"
  },
  {
    label: "Tatar",
    value: "tt"
  },
  {
    label: "Telugu",
    value: "te"
  },
  {
    label: "Thai",
    value: "th"
  },
  {
    label: "Tibetan Standard, Tibetan, Central",
    value: "bo"
  },
  {
    label: "Tigrinya",
    value: "ti"
  },
  {
    label: "Tonga (Tonga Islands)",
    value: "to"
  },
  {
    label: "Tsonga",
    value: "ts"
  },
  {
    label: "Tswana",
    value: "tn"
  },
  {
    label: "Turkish",
    value: "tr"
  },
  {
    label: "Turkmen",
    value: "tk"
  },
  {
    label: "Twi",
    value: "tw"
  },
  {
    label: "Ukrainian",
    value: "uk"
  },
  {
    label: "Urdu",
    value: "ur"
  },
  {
    label: "Uyghur",
    value: "ug"
  },
  {
    label: "Uzbek",
    value: "uz"
  },
  {
    label: "Uzbek - Cyrillic",
    value: "uz-uz"
  },
  {
    label: "Uzbek - Latin",
    value: "uz-uz"
  },
  {
    label: "Venda",
    value: "ve"
  },
  {
    label: "Vietnamese",
    value: "vi"
  },
  {
    label: "Volap\xFCk",
    value: "vo"
  },
  {
    label: "Walloon",
    value: "wa"
  },
  {
    label: "Welsh",
    value: "cy"
  },
  {
    label: "Western Frisian",
    value: "fy"
  },
  {
    label: "Wolof",
    value: "wo"
  },
  {
    label: "Xhosa",
    value: "xh"
  },
  {
    label: "Yiddish",
    value: "yi"
  },
  {
    label: "Yoruba",
    value: "yo"
  },
  {
    label: "Zhuang, Chuang",
    value: "za"
  },
  {
    label: "Zulu",
    value: "zu"
  }
];

// src/components/constants/stepTypes.js
var STEP_TYPE_IDS = {
  JOURNEY: "journey",
  SATISFACTION: "satisfaction-survey",
  MODAL: "modal",
  HOTSPOT_GROUP: "hotspot-group",
  TOOLTIP_GROUP: "tooltip-group",
  SLIDEOUT: "shorty",
  REDIRECT: "redirect",
  COACHMARK_GROUP: "coachmark-group",
  CHECKLIST: "checklist",
  WAIT_FOR_PAGE: "wait-for-page",
  UNKNOWN: "unknown"
};

// src/components/helpers.js
var AUDIENCES_CLAUSES = [
  "properties",
  "groups",
  "languages",
  "content",
  "mobile",
  "pins",
  "banners",
  "checklists",
  "event",
  "segments"
];
var getLeafNodes = (conditions = {}) => {
  const { _qualified, ...restConditions } = conditions || {};
  const [clauseType] = Object.keys(restConditions);
  if (["and", "or", "not"].includes(clauseType)) {
    return conditions[clauseType].flatMap(getLeafNodes);
  }
  return Object.keys(conditions != null ? conditions : {}).length > 0 ? conditions : [];
};
var evaluate = (url, conditions) => {
  const [firstKey] = Object.keys(conditions);
  if (["and", "or", "not"].includes(firstKey)) {
    if (firstKey === "and") {
      return conditions[firstKey].every((condition) => {
        return evaluate(url, condition);
      });
    }
    if (firstKey === "or") {
      return conditions[firstKey].some((condition) => {
        return evaluate(url, condition);
      });
    }
    if (firstKey === "not") {
      return !conditions[firstKey].some((condition) => {
        return evaluate(url, condition);
      });
    }
  }
  const { hostname: domain, pathname, search, hash } = new URL(url);
  const urlPath = `${pathname}${search}${hash}`;
  const opertateOn = conditions.url ? urlPath : domain;
  const { operator, value } = conditions.url || conditions.domains;
  if (firstKey === "domains" && operator === "==") {
    const clauseDomain = conditions.domains.value.toLowerCase();
    const domainMask = import_fuzzyurl.default.mask({ hostname: clauseDomain });
    const lowerCaseDomain = domain.toLowerCase();
    return import_fuzzyurl.default.matches(domainMask, lowerCaseDomain);
  }
  switch (operator) {
    case "^":
      return opertateOn.startsWith(value);
    case "!^":
      return !opertateOn.startsWith(value);
    case "$":
      return opertateOn.endsWith(value);
    case "!$":
      return !opertateOn.endsWith(value);
    case "*":
      return opertateOn.includes(value);
    case "!*":
      return !opertateOn.includes(value);
    case "!=":
      return opertateOn !== value;
    case "regex":
      try {
        return new RegExp(value).test(opertateOn);
      } catch (e) {
        return false;
      }
    case "==":
    default:
      return opertateOn === value;
  }
};
var hasMatchingSegment = (conditions = {}, segmentId) => {
  var _a;
  const condition = conditions.or || conditions.and || conditions.not;
  if (condition) {
    return condition.some((item) => hasMatchingSegment(item, segmentId));
  }
  return ((_a = conditions == null ? void 0 : conditions.segments) == null ? void 0 : _a.segment) === segmentId;
};
var getAudienceConditions = (conditions = {}) => getLeafNodes(conditions).filter((node) => {
  const [type] = Object.keys(node);
  return AUDIENCES_CLAUSES.includes(type);
});
var filterImmutableExperienceSections = ({
  and: branches = []
} = {}) => {
  const dismissed = branches.find((branch) => {
    return getLeafNodes(branch).some(
      (node) => {
        var _a;
        return node.experienceDismissed && !((_a = node.experienceDismissed) == null ? void 0 : _a.type);
      }
    );
  });
  const immutableBranches = { dismissed };
  return [
    immutableBranches,
    branches.filter(
      (branch) => !Object.values(immutableBranches).includes(branch)
    )
  ];
};
var getBannerTargetingSections = (conditions) => {
  const [immutableBranches, mutableBranches] = filterImmutableExperienceSections(conditions);
  return {
    url: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url }) => Boolean(url))
    ),
    domains: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ domains }) => Boolean(domains))
    ),
    audience: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url, domains }) => !url && !domains)
    ),
    ...immutableBranches
  };
};
var getLaunchpadTargetingSections = (conditions) => {
  const [immutableBranches, mutableBranches] = filterImmutableExperienceSections(conditions);
  return {
    url: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url }) => Boolean(url))
    ),
    domains: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ domains }) => Boolean(domains))
    ),
    audience: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url, domains }) => !url && !domains)
    ),
    ...immutableBranches
  };
};
var getPinTargetingSections = (conditions) => {
  const [immutableBranches, mutableBranches] = filterImmutableExperienceSections(conditions);
  return {
    url: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url }) => Boolean(url))
    ),
    domains: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ domains }) => Boolean(domains))
    ),
    audience: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ url, domains }) => !url && !domains)
    ),
    ...immutableBranches
  };
};
var getSegments = (conditions) => getLeafNodes(conditions).filter(({ segments }) => Boolean(segments));
var getDomains = (conditions) => getLeafNodes(conditions).filter(({ domains }) => Boolean(domains) && domains.operator === "==").map(({ domains: { value } }) => value).filter(Boolean);
var NON_AUDIENCE_TYPES = ["app", "trigger", "screen", "version"];
var getMobileTargetingSections = (conditions) => {
  const [immutableBranches, mutableBranches] = filterImmutableExperienceSections(conditions);
  return {
    app: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ app }) => Boolean(app))
    ),
    trigger: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ trigger }) => Boolean(trigger))
    ),
    screen: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ screen }) => Boolean(screen))
    ),
    version: mutableBranches.find(
      (branch) => getLeafNodes(branch).some(({ version }) => Boolean(version))
    ),
    audience: mutableBranches.find(
      (branch) => getLeafNodes(branch).every(
        (clause) => NON_AUDIENCE_TYPES.every((type) => !clause[type])
      )
    ),
    ...immutableBranches
  };
};
function getCompletionEventLabel(stepType) {
  return stepType && [STEP_TYPE_IDS.MODAL, STEP_TYPE_IDS.SLIDEOUT].includes(stepType) ? "seen" : "completed";
}

// src/components/actions.js
var GROUP_UPDATED = "GROUP_UPDATED";
var updateGroup = (conditions) => ({
  type: GROUP_UPDATED,
  payload: conditions
});
var CLAUSE_ADDED = "CLAUSE_ADDED";
var addClause = () => ({
  type: CLAUSE_ADDED,
  payload: {}
});
var CLAUSE_UPDATED = "CLAUSE_UPDATED";
var updateClause = (index, changes, negated) => ({
  type: CLAUSE_UPDATED,
  payload: { index, changes, negated }
});
var CLAUSE_DELETED = "CLAUSE_DELETED";
var deleteClause = (index) => ({
  type: CLAUSE_DELETED,
  payload: { index }
});
var GROUP_CLAUSE_ADDED = "GROUP_CLAUSE_ADDED";
var addGroup = () => ({
  type: GROUP_CLAUSE_ADDED,
  payload: {}
});
var GROUP_UNGROUPED = "GROUP_UNGROUPED";
var ungroup = () => ({
  type: GROUP_UNGROUPED,
  payload: {}
});
var GROUP_DELETED = "GROUP_DELETED";
var deleteGroup = () => ({
  type: GROUP_DELETED,
  payload: {}
});

// src/components/reducer.js
var conditionsReducer = (conditions, { type, payload }) => {
  var _a, _b;
  const [[groupType, clauses]] = Object.entries(conditions);
  switch (type) {
    case GROUP_UPDATED:
      return { [payload]: clauses };
    case CLAUSE_ADDED: {
      const [lastClause] = getLeafNodes(conditions).slice(-1);
      const [lastClauseType] = Object.keys(lastClause);
      return {
        [groupType]: [
          ...clauses,
          {
            [lastClauseType]: ((_a = lastClause[lastClauseType]) == null ? void 0 : _a.type) ? { type: lastClause[lastClauseType].type } : {}
          }
        ]
      };
    }
    case CLAUSE_UPDATED: {
      const { index, changes, negated = false } = payload;
      const nextClause = negated ? { not: [changes] } : changes;
      return {
        [groupType]: [
          ...clauses.slice(0, index),
          ...changes ? Array.isArray(changes) ? changes : [nextClause] : [],
          ...clauses.slice(index + 1)
        ]
      };
    }
    case CLAUSE_DELETED: {
      const { index } = payload;
      return {
        [groupType]: [...clauses.slice(0, index), ...clauses.slice(index + 1)]
      };
    }
    case GROUP_CLAUSE_ADDED: {
      const [lastClause] = getLeafNodes(conditions).slice(-1);
      const [lastClauseType] = Object.keys(lastClause);
      return {
        [groupType]: [
          ...clauses,
          {
            [groupType]: [
              {
                [lastClauseType]: ((_b = lastClause[lastClauseType]) == null ? void 0 : _b.type) ? {
                  type: lastClause[lastClauseType].type
                } : {}
              }
            ]
          }
        ]
      };
    }
    case GROUP_UNGROUPED:
      return clauses;
    case GROUP_DELETED:
      return null;
    default:
      return conditions;
  }
};

// src/components/BannersClause.tsx
var import_react21 = require("react");
var import_legacy_components18 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var SEEN_EVENT_OPTIONS2 = [
  {
    label: "has been seen",
    value: "has been seen",
    negation: false
  },
  {
    label: "has not been seen",
    value: "has not been seen",
    negation: true
  }
];
var DISMISSED_EVENT_OPTIONS = [
  {
    label: "has been dismissed",
    value: "has been dismissed",
    negation: false
  },
  {
    label: "has not been dismissed",
    value: "has not been dismissed",
    negation: true
  }
];
var getCondition = ({ value, negation }, experience) => {
  if (value.includes("dismissed")) {
    return {
      experienceDismissed: {
        experienceId: experience.id,
        operator: negation ? "!=" : "==",
        value: "permanently_dismissed",
        type: "banners"
      }
    };
  }
  return {
    experienceStep: {
      experienceStep: experience == null ? void 0 : experience.stepId,
      type: "banners"
    }
  };
};
var BannersClause = ({ conditions, negated, onChange }) => {
  const { experienceStep: { experienceStep } = {} } = conditions;
  const { experienceDismissed } = conditions;
  const { experienceId } = experienceDismissed || { experienceId: "" };
  const conditionOptions = [...SEEN_EVENT_OPTIONS2, ...DISMISSED_EVENT_OPTIONS];
  const { bannerOptions = [] } = (0, import_react21.useContext)(ConditionsContext);
  const bannersOptions = (0, import_react21.useMemo)(() => [...bannerOptions], [bannerOptions]);
  if (experienceStep && !bannersOptions.some(({ stepId }) => stepId === experienceStep)) {
    bannersOptions.push({
      label: experienceStep,
      value: experienceStep,
      stepId: experienceStep
    });
  }
  const selectedExperience = (0, import_react21.useMemo)(() => {
    const experienceData = {
      stepId: experienceStep,
      experienceId
    };
    return bannersOptions.find(
      ({ value: bannerId, stepId }) => bannerId === experienceData.experienceId || stepId === experienceData.stepId
    );
  }, [bannersOptions, experienceStep, experienceId]);
  const selectedOption = (0, import_react21.useMemo)(() => {
    if (experienceDismissed) {
      const isNegation = experienceDismissed.operator === "!=";
      return DISMISSED_EVENT_OPTIONS.find(
        (event) => event.negation === isNegation
      );
    }
    return SEEN_EVENT_OPTIONS2.find(
      (event) => event.negation === negated
    );
  }, [negated, experienceDismissed]);
  const handleBannerChange = ({
    value: bannerId,
    stepId
  }) => {
    onChange(
      { ...getCondition(selectedOption, { id: bannerId, stepId }) },
      negated
    );
  };
  const handleConditionChange = (0, import_react21.useCallback)(
    (newCondition) => {
      const { negation } = newCondition;
      const condition = getCondition(newCondition, {
        id: selectedExperience == null ? void 0 : selectedExperience.value,
        stepId: selectedExperience == null ? void 0 : selectedExperience.stepId
      });
      if (condition.experienceDismissed) {
        onChange({ ...condition }, false);
        return;
      }
      onChange({ ...condition }, negation);
    },
    [onChange, selectedExperience]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ClauseWrapper, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Clause, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components18.Select, {
          value: selectedExperience,
          options: bannersOptions,
          onChange: handleBannerChange,
          portal: true,
          menuShouldBlockScroll: true
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components18.Select, {
          value: selectedOption,
          options: conditionOptions,
          onChange: handleConditionChange,
          portal: true,
          menuShouldBlockScroll: true
        })
      ]
    })
  });
};

// src/components/Group.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CLAUSE_TYPES = {
  url: UrlClause,
  version: VersionClause,
  properties: PropertiesClause,
  groups: GroupsClause,
  languages: LanguagesClause,
  content: ContentClause,
  mobile: MobileContentClause,
  event: EventClause,
  segments: SegmentsClause,
  checklists: ChecklistsClause,
  screen: ScreenClause,
  attributes: AttributesClause,
  pins: PinsClause,
  banners: BannersClause
};
function generateUniqueId() {
  return `key-${Math.random().toString(36).slice(2, 11)}`;
}
var Group = ({
  conditions,
  isProtected = false,
  isRoot = true,
  onChange,
  disableGroupControls = false,
  ...unhandledProps
}) => {
  const {
    canTargetChecklists,
    canTargetBanners,
    checklistOptions,
    eventOptions,
    flowOptions,
    mobileFlowOptions,
    groupOptions,
    segmentOptions,
    validClauseTypes,
    propertiesClauseOperators,
    pinOptions,
    bannerOptions,
    conditionsOptions
  } = (0, import_react22.useContext)(ConditionsContext);
  const [[type, clauses]] = Object.entries(conditions);
  const dispatch = (action) => void onChange(conditionsReducer(conditions, action));
  const [firstSubCondition] = clauses;
  const [firstSubConditionType] = Object.keys(firstSubCondition);
  const hideGroupControls = isRoot && clauses.length === 1 && !["and", "or"].includes(firstSubConditionType);
  const [deletedIndex, setDeletedIndex] = (0, import_react22.useState)(0);
  const clauseIds = (0, import_react22.useMemo)(() => {
    const ids = clauses.map(() => generateUniqueId());
    if (clauses.length < ids.length) {
      return [...ids.slice(0, deletedIndex), ...ids.slice(deletedIndex + 1)];
    }
    return ids;
  }, [clauses, deletedIndex]);
  const clauseTypeOptions = validClauseTypes.map((value) => {
    switch (value) {
      case "url":
        return { value, label: "Path" };
      case "properties":
        return { value, label: "User Property" };
      case "groups":
        return {
          value,
          label: "Group Property",
          isDisabled: groupOptions.length === 0
        };
      case "languages":
        return { value, label: "Language" };
      case "content":
        return {
          value,
          label: "Flow",
          isDisabled: flowOptions.length === 0
        };
      case "mobile":
        return {
          value,
          label: "Mobile Flow",
          isDisabled: mobileFlowOptions.length === 0
        };
      case "event":
        return {
          value,
          label: "Event",
          isDisabled: eventOptions.length === 0
        };
      case "segments":
        return {
          value,
          label: "Segment",
          isDisabled: segmentOptions.length === 0
        };
      case "checklists":
        return {
          value,
          label: canTargetChecklists ? "Checklist" : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              "Checklist",
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UpgradeBadge, {
                label: "Upgrade",
                icon: "magic"
              })
            ]
          }),
          isDisabled: !canTargetChecklists || checklistOptions.length === 0
        };
      case "screen":
        return {
          value,
          label: "Screen"
        };
      case "attributes":
        return { value, label: "Attributes" };
      case "pins":
        return {
          value,
          label: "Pins",
          isDisabled: pinOptions.length === 0
        };
      case "banners": {
        return {
          value,
          label: "Banners",
          isDisabled: !canTargetBanners || bannerOptions.length === 0
        };
      }
      default:
        return { value };
    }
  });
  const handleSubConditionChange = (index) => (changes, negated = false) => {
    dispatch(updateClause(index, changes, negated));
  };
  const handleSubConditionDelete = (index) => () => {
    setDeletedIndex(index);
    if (clauses.length === 1) {
      dispatch(deleteGroup());
    } else {
      dispatch(deleteClause(index));
    }
  };
  const handleSubConditionTypeChange = (index) => ({ value: newSubConditionType }) => {
    let newSubCondition;
    if (newSubConditionType === "mobile") {
      newSubCondition = "experience";
    } else if (newSubConditionType === "pins" || newSubConditionType === "banners") {
      newSubCondition = "experienceStep";
    } else {
      newSubCondition = newSubConditionType;
    }
    void handleSubConditionChange(index)(
      getEmptyClause(newSubCondition, newSubConditionType),
      false
    );
  };
  const typeLabel = type === "and" ? "All" : "Any";
  const hasGroupControls = !disableGroupControls;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionsWrapper, {
    ...unhandledProps,
    children: [
      !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(BracketWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Select, {
            isSearchable: false,
            name: "type",
            portal: true,
            menuShouldBlockScroll: true,
            value: conditionsOptions.find(({ value }) => value === type),
            options: conditionsOptions,
            onChange: ({ value }) => void dispatch(updateGroup(value))
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Bracket, {
            type
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Content, {
        children: [
          !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionsType, {
            children: [
              typeLabel,
              " of the following conditions match"
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Children, {
            children: clauses.map((subConditions, index) => {
              let not;
              const restSubConditions = subConditions;
              if (Object.hasOwn(subConditions, "not")) {
                ({ not } = subConditions);
              }
              const [subCondition] = not || [restSubConditions];
              const [subConditionType] = Object.keys(subCondition);
              const [subConditionValue] = Object.values(subCondition);
              const conditionsKey = clauseIds[index];
              if (["and", "or"].includes(subConditionType)) {
                return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Group, {
                  id: conditionsKey,
                  conditions: subCondition,
                  isRoot: false,
                  isProtected: clauses.length === 1,
                  onChange: handleSubConditionChange(index)
                }, conditionsKey);
              }
              const clauseType = subConditionType === "experience" || subConditionType === "experienceDismissed" || subConditionType === "experienceStep" ? subConditionValue.type : subConditionType;
              const Clause2 = CLAUSE_TYPES[clauseType];
              if (!Clause2)
                return null;
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Child, {
                children: [
                  clauseTypeOptions.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Select, {
                    value: clauseTypeOptions.find(
                      ({ value: optionType }) => optionType === clauseType
                    ),
                    options: clauseTypeOptions,
                    onChange: handleSubConditionTypeChange(index),
                    portal: true,
                    menuShouldBlockScroll: true
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Clause2, {
                    conditions: subCondition,
                    negated: !!not,
                    ...clauseType === "properties" ? { propertiesClauseOperators } : {},
                    onChange: handleSubConditionChange(index)
                  }, conditionsKey),
                  !hideGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.IconButton, {
                    kind: "negative",
                    icon: "trash-alt",
                    "aria-label": "remove",
                    disabled: (isRoot || isProtected) && clauses.length === 1,
                    onClick: handleSubConditionDelete(index)
                  })
                ]
              }, conditionsKey);
            })
          }),
          hasGroupControls && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.ButtonGroup, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.SplitButton, {
                kind: "positive",
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Button, {
                    onClick: () => void dispatch(addClause()),
                    children: "Add condition"
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Dropdown, {
                    "aria-label": "Open additional options",
                    name: "Open additional options",
                    forwardedAs: import_legacy_components19.Button,
                    attachment: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.MenuList, {
                      options: [
                        {
                          label: "Add condition",
                          onClick: () => void dispatch(addClause())
                        },
                        {
                          label: "Add condition group",
                          onClick: () => void dispatch(addGroup())
                        }
                      ]
                    }),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Icon, {
                      icon: "chevron-down"
                    })
                  })
                ]
              }),
              !isRoot && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_legacy_components19.Button, {
                kind: "secondary",
                onClick: () => void dispatch(ungroup()),
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_legacy_components19.Icon, {
                    icon: "unlink"
                  }),
                  " Ungroup"
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/shape.js
var AppShape = import_prop_types.default.exact({
  app: import_prop_types.default.exact({
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.string.isRequired
  })
});
var URLShape = import_prop_types.default.exact({
  url: import_prop_types.default.exact({
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.string
  })
});
var DomainsShape = import_prop_types.default.exact({
  domains: import_prop_types.default.exact({
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.string.isRequired
  })
});
var PropertiesShape = import_prop_types.default.exact({
  properties: import_prop_types.default.exact({
    property: import_prop_types.default.string.isRequired,
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number])
  })
});
var GroupsShape = import_prop_types.default.exact({
  groups: import_prop_types.default.exact({
    property: import_prop_types.default.string.isRequired,
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.number])
  })
});
var LanguagesShape = import_prop_types.default.exact({
  languages: import_prop_types.default.exact({
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.string.isRequired
  })
});
var ContentShape = import_prop_types.default.exact({
  content: import_prop_types.default.exact({
    content: import_prop_types.default.string.isRequired,
    operator: import_prop_types.default.string,
    times: import_prop_types.default.number,
    value: import_prop_types.default.number
  })
});
var ExperienceShape = import_prop_types.default.exact({
  experience: import_prop_types.default.exact({
    experience: import_prop_types.default.string,
    type: import_prop_types.default.oneOf(["pins", "mobile"]),
    operator: import_prop_types.default.string,
    value: import_prop_types.default.string,
    operator_attribute: import_prop_types.default.string
  })
});
var ExperienceStepShape = import_prop_types.default.exact({
  experienceStep: import_prop_types.default.exact({
    experienceStep: import_prop_types.default.string,
    type: import_prop_types.default.oneOf(["pins", "mobile"])
  })
});
var EventShape = import_prop_types.default.exact({
  event: import_prop_types.default.exact({
    event: import_prop_types.default.string.isRequired,
    operator: import_prop_types.default.string,
    times: import_prop_types.default.number,
    value: import_prop_types.default.number
  })
});
var SegmentsShape = import_prop_types.default.exact({
  segments: import_prop_types.default.exact({
    segment: import_prop_types.default.string
  })
});
var ChecklistsShape = import_prop_types.default.exact({
  checklists: import_prop_types.default.exact({
    checklist: import_prop_types.default.string.isRequired,
    status: import_prop_types.default.oneOf(["in_progress", "skipped", "completed\ndismissed"])
  })
});
var AttributesShape = import_prop_types.default.exact({
  attributes: import_prop_types.default.exact({
    attribute: import_prop_types.default.string.isRequired,
    operator: import_prop_types.default.string.isRequired,
    value: import_prop_types.default.string
  })
});
var TriggerShape = import_prop_types.default.exact({
  trigger: import_prop_types.default.exact({
    event: import_prop_types.default.string
  })
});
var ScreenShape = import_prop_types.default.exact({
  screen: import_prop_types.default.exact({
    operator: import_prop_types.default.string,
    value: import_prop_types.default.string
  })
});
var VersionShape = import_prop_types.default.exact({
  version: import_prop_types.default.exact({
    operator: import_prop_types.default.string,
    value: import_prop_types.default.string
  })
});
var AndShape = {};
var OrShape = {};
var NotShape = {};
var ConditionsShape = import_prop_types.default.oneOfType([
  AppShape,
  URLShape,
  DomainsShape,
  PropertiesShape,
  GroupsShape,
  LanguagesShape,
  ContentShape,
  EventShape,
  SegmentsShape,
  AttributesShape,
  ChecklistsShape,
  TriggerShape,
  ScreenShape,
  VersionShape,
  ExperienceShape,
  ExperienceStepShape,
  import_prop_types.default.exact(AndShape),
  import_prop_types.default.exact(OrShape),
  import_prop_types.default.exact(NotShape)
]);
AndShape.and = import_prop_types.default.arrayOf(ConditionsShape);
OrShape.or = import_prop_types.default.arrayOf(ConditionsShape);
NotShape.not = import_prop_types.default.arrayOf(ConditionsShape);
var FrequencyShape = import_prop_types.default.oneOf(["every_time", "never", "once"]);
var FullShape = {
  conditions: ConditionsShape,
  contentType: import_prop_types.default.oneOf([
    "journey",
    "satisfaction-survey",
    "experience"
  ]),
  createdAt: import_prop_types.default.number,
  createdBy: import_prop_types.default.string,
  frequency: FrequencyShape,
  goals: import_prop_types.default.arrayOf(import_prop_types.default.string),
  id: import_prop_types.default.string,
  migratedFromStepId: import_prop_types.default.string,
  name: import_prop_types.default.string,
  nextContentId: import_prop_types.default.string,
  published: import_prop_types.default.bool,
  redirectNewTab: import_prop_types.default.bool,
  redirectUrl: import_prop_types.default.string,
  sortPriority: import_prop_types.default.number,
  source: import_prop_types.default.oneOf(["CONTENT-API", "CRX", "MY.APPCUES"]),
  state: import_prop_types.default.oneOf(["ARCHIVED", "DRAFT"]),
  testFlowId: import_prop_types.default.string,
  testVersionOf: import_prop_types.default.string,
  throttleExempt: import_prop_types.default.bool,
  unpublishedAt: import_prop_types.default.number,
  unpublishedBy: import_prop_types.default.string,
  updatedAt: import_prop_types.default.number,
  updatedBy: import_prop_types.default.string,
  widgetFilter: import_prop_types.default.oneOf(["exclude", "include", "page"])
};
var allowed = [
  "conditions",
  "id",
  "contentType",
  "sortPriority",
  "published",
  "frequency",
  "goals"
];
var parse = (rule) => (0, import_lodash.default)(rule, allowed);
var Shape = import_prop_types.default.shape(parse(FullShape));
var OptionShape = import_prop_types.default.shape({
  label: import_prop_types.default.string,
  value: import_prop_types.default.string,
  icon: import_prop_types.default.oneOfType([
    import_prop_types.default.string,
    import_prop_types.default.arrayOf(import_prop_types.default.string)
  ])
});
var OptionsListShape = import_prop_types.default.arrayOf(OptionShape);
var SelectOptionsShape = import_prop_types.default.oneOfType([
  OptionsListShape,
  import_prop_types.default.shape({
    label: import_prop_types.default.string,
    options: OptionsListShape
  })
]);
var ConditionsPropsShape = import_prop_types.default.shape({
  checklistOptions: SelectOptionsShape,
  eventOptions: SelectOptionsShape,
  flowOptions: SelectOptionsShape,
  mobileFlowOptions: SelectOptionsShape,
  groupOptions: SelectOptionsShape,
  hasChecklistTargeting: import_prop_types.default.bool,
  propertyOptions: SelectOptionsShape,
  segmentOptions: SelectOptionsShape,
  validClauseTypes: import_prop_types.default.arrayOf(
    import_prop_types.default.oneOf(Object.keys(CLAUSE_TYPES))
  ),
  pinOptions: SelectOptionsShape,
  bannerOptions: SelectOptionsShape,
  hasBannerTargeting: import_prop_types.default.bool
});

// src/components/ReadableConditions/ChecklistCondition.jsx
var import_react23 = __toESM(require("react"));
var import_prop_types2 = __toESM(require("prop-types"));
var import_legacy_components20 = require("@studio/legacy-components");

// src/components/ReadableConditions/styled.jsx
var import_styled_components3 = __toESM(require("styled-components"));
var ConditionText = import_styled_components3.default.span``;
var SubGroup = import_styled_components3.default.span``;
var Highlight = import_styled_components3.default.span``;
var OrCondition = import_styled_components3.default.span``;
var AndCondition = import_styled_components3.default.span``;

// src/components/ReadableConditions/ChecklistCondition.jsx
var import_jsx_runtime = require("react/jsx-runtime");
var CHECKLIST_STATUS_NAMES = {
  in_progress: "be in progress",
  skipped: "have been skipped",
  "completed\ndismissed": "have been completed"
};
var ChecklistCondition = ({
  checklists,
  status,
  checklist: checklistId,
  Link = import_legacy_components20.Link
}) => {
  var _a;
  const checklistName = (_a = checklists == null ? void 0 : checklists[checklistId]) == null ? void 0 : _a.internalName;
  const checklistLink = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
    to: `/checklists/${checklistId}/analytics`,
    target: "_blank",
    children: checklistName || checklistId
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "checklist ",
      checklistLink,
      " must",
      " ",
      CHECKLIST_STATUS_NAMES[status] || "not have been seen"
    ]
  });
};
ChecklistCondition.propTypes = {
  status: import_prop_types2.default.string,
  checklist: import_prop_types2.default.string,
  checklists: import_prop_types2.default.objectOf(
    import_prop_types2.default.shape({
      internalName: import_prop_types2.default.string,
      id: import_prop_types2.default.string
    })
  ),
  Link: import_prop_types2.default.elementType
};
var ChecklistCondition_default = ChecklistCondition;

// src/components/ReadableConditions/FlowCondition.jsx
var import_react24 = __toESM(require("react"));
var import_prop_types3 = __toESM(require("prop-types"));
var import_legacy_components21 = require("@studio/legacy-components");

// src/lib/date.js
var import_moment = __toESM(require("moment"));
var format = (date, tokens) => {
  return (0, import_moment.default)(date).format(tokens);
};

// src/components/ReadableConditions/FlowCondition.jsx
var import_jsx_runtime = require("react/jsx-runtime");
var FlowCondition = ({
  operator,
  value,
  times = 1,
  negated,
  content: flowId,
  flows = {},
  Link = import_legacy_components21.Link
}) => {
  const flowOptions = Object.values(flows).flatMap(
    ({ name: flowName2, steps = {} }) => {
      var _a;
      return ((_a = Object.values(steps)) != null ? _a : []).map((step2) => {
        var _a2;
        return {
          value: step2 == null ? void 0 : step2.id,
          label: `${flowName2} (Step ${((_a2 = step2 == null ? void 0 : step2.index) != null ? _a2 : 0) + 1})`,
          stepType: step2 == null ? void 0 : step2.stepType
        };
      });
    }
  );
  const step = flowOptions.find((option) => option.value === flowId);
  const verb = step ? getCompletionEventLabel(step.stepType) : "seen";
  const flowName = step == null ? void 0 : step.label;
  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);
  const flowLink = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
    to: `/flows/${flowId}/analytics`,
    target: "_blank",
    children: flowName || flowId
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "flow ",
      flowLink,
      " has ",
      negated ? "not" : "",
      " been ",
      verb,
      " at least ",
      times,
      " ",
      "time",
      times > 1 ? "s" : "",
      " ",
      operator === "< ago" && `in the last ${numOfDays} day${numOfDays > 1 ? "s" : ""}`,
      operator === "since" && `since ${format(value, "ddd MMM D YYYY")}`
    ]
  });
};
FlowCondition.propTypes = {
  content: import_prop_types3.default.string,
  operator: import_prop_types3.default.string.isRequired,
  flows: import_prop_types3.default.objectOf(
    import_prop_types3.default.shape({
      name: import_prop_types3.default.string
    })
  ),
  value: import_prop_types3.default.number,
  times: import_prop_types3.default.number.isRequired,
  negated: import_prop_types3.default.bool,
  Link: import_prop_types3.default.elementType
};
var FlowCondition_default = FlowCondition;

// src/components/ReadableConditions/LanguageCondition.jsx
var import_react25 = __toESM(require("react"));
var import_prop_types4 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var LanguageCondition = ({ value, negated }) => {
  var _a;
  const language = (_a = LANGUAGE_OPTIONS.find((item) => item.value === value)) == null ? void 0 : _a.label;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "language must ",
      negated ? "not" : "",
      " be ",
      language
    ]
  });
};
LanguageCondition.propTypes = {
  value: import_prop_types4.default.string.isRequired,
  negated: import_prop_types4.default.bool
};
var LanguageCondition_default = LanguageCondition;

// src/components/ReadableConditions/SegmentCondition.jsx
var import_react26 = __toESM(require("react"));
var import_legacy_components22 = require("@studio/legacy-components");
var import_prop_types5 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var SegmentCondition = ({
  negated,
  segment: segmentId,
  segments,
  Link = import_legacy_components22.Link
}) => {
  var _a;
  const segmentName = (_a = segments == null ? void 0 : segments[segmentId]) == null ? void 0 : _a.name;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "user must",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Highlight, {
        children: negated ? " not" : ""
      }),
      " belong to",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Highlight, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
          to: `/segments/${segmentId}/view`,
          children: segmentName || segmentId
        })
      })
    ]
  });
};
SegmentCondition.propTypes = {
  segment: import_prop_types5.default.string,
  negated: import_prop_types5.default.bool,
  segments: import_prop_types5.default.objectOf(
    import_prop_types5.default.shape({
      name: import_prop_types5.default.string,
      id: import_prop_types5.default.string
    })
  ),
  Link: import_prop_types5.default.elementType
};
var SegmentCondition_default = SegmentCondition;

// src/components/ReadableConditions/DomainCondition.jsx
var import_react27 = __toESM(require("react"));
var import_prop_types6 = __toESM(require("prop-types"));

// src/components/ReadableConditions/constants.js
var OPERATOR_NAMES = {
  "==": "equal",
  "*": "contain",
  "!=": "not equal",
  ">": "be greater than",
  "<": "be less than",
  ">=": "be greater than or equal to",
  "<=": "be less than or equal to",
  "!*": "not contain",
  "^": "starts with",
  "!^": "not start with",
  $: "ends with",
  "!$": "not end with",
  "?": "exist",
  "!?": "not exist",
  in: "be one of",
  "not in": "not be one of",
  since: "since",
  regex: "regex",
  "> ago": "have occurred more than",
  "< ago": "have occurred less than",
  within: "have occurred in the last",
  "< time": "have occurred before",
  "> time": "have occurred after"
};

// src/components/ReadableConditions/DomainCondition.jsx
var import_jsx_runtime = require("react/jsx-runtime");
var DomainCondition = ({ operator, value }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
  children: [
    "environment must ",
    OPERATOR_NAMES[operator],
    " ",
    value
  ]
});
DomainCondition.propTypes = {
  operator: import_prop_types6.default.string.isRequired,
  value: import_prop_types6.default.string.isRequired
};

// src/components/ReadableConditions/EventCondition.jsx
var import_react28 = __toESM(require("react"));
var import_prop_types7 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var EventCondition = ({
  event,
  operator,
  value,
  times = 1,
  negated
}) => {
  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);
  const displayEvent = event ? event.replace("appcues_custom:", "") : "(not selected)";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "event ",
      displayEvent,
      " has ",
      negated ? "not" : "",
      " occurred at least ",
      times,
      " ",
      "time",
      times > 1 ? "s" : "",
      " ",
      operator === "< ago" && `in the last ${numOfDays} day${numOfDays > 1 ? "s" : ""}`,
      operator === "since" && `since ${format(value, "ddd MMM D YYYY")}`
    ]
  });
};
EventCondition.propTypes = {
  event: import_prop_types7.default.string.isRequired,
  operator: import_prop_types7.default.string.isRequired,
  value: import_prop_types7.default.number.isRequired,
  times: import_prop_types7.default.number.isRequired,
  negated: import_prop_types7.default.bool
};

// src/components/ReadableConditions/GroupCondition.jsx
var import_react29 = __toESM(require("react"));
var import_prop_types8 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var GroupCondition = ({ operator, value, property }) => {
  const isDefaultOperator = DEFAULT_OPERATORS.has(operator) || NUMERIC_OPERATORS.has(operator);
  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "group property ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Highlight, {
        children: getPropertyDisplayName(property)
      }),
      " ",
      "must ",
      OPERATOR_NAMES[operator],
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Highlight, {
        children: [
          isDefaultOperator && value,
          MULTI_VALUE_OPERATORS.has(operator) && `${value.split("\n").length} values`,
          RELATIVE_TIME_OPERATORS.has(operator) && `
          ${numOfDays} day${numOfDays > 1 ? "s" : ""} ago
        `,
          ABSOLUTE_TIME_OPERATORS.has(operator) && `
          ${format(value, "MMMM Do YYYY")}
        `
        ]
      })
    ]
  });
};
GroupCondition.propTypes = {
  property: import_prop_types8.default.string.isRequired,
  operator: import_prop_types8.default.string.isRequired,
  value: import_prop_types8.default.oneOfType([import_prop_types8.default.string, import_prop_types8.default.number])
};

// src/components/ReadableConditions/PropertyCondition.jsx
var import_react30 = __toESM(require("react"));
var import_prop_types9 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var PropertyCondition = ({
  property,
  operator,
  value,
  properties
}) => {
  const isDefaultOperator = DEFAULT_OPERATORS.has(operator) || NUMERIC_OPERATORS.has(operator);
  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);
  const customProp = properties == null ? void 0 : properties[property];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "user property",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Highlight, {
        children: (customProp == null ? void 0 : customProp.label) || getPropertyDisplayName(property)
      }),
      " ",
      "must ",
      OPERATOR_NAMES[operator],
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Highlight, {
        children: [
          isDefaultOperator && value,
          MULTI_VALUE_OPERATORS.has(operator) && `${value.split("\n").length} values`,
          RELATIVE_TIME_OPERATORS.has(operator) && `
          ${numOfDays} day${numOfDays > 1 ? "s" : ""} ago
        `,
          ABSOLUTE_TIME_OPERATORS.has(operator) && `
          ${format(Number.parseInt(value, 10), "MMMM Do YYYY")}
        `
        ]
      })
    ]
  });
};
PropertyCondition.propTypes = {
  property: import_prop_types9.default.string.isRequired,
  operator: import_prop_types9.default.string.isRequired,
  value: import_prop_types9.default.oneOfType([import_prop_types9.default.string, import_prop_types9.default.number]).isRequired,
  properties: import_prop_types9.default.objectOf(
    import_prop_types9.default.shape({
      name: import_prop_types9.default.string,
      label: import_prop_types9.default.string,
      id: import_prop_types9.default.string
    })
  )
};

// src/components/ReadableConditions/UrlCondition.jsx
var import_react31 = __toESM(require("react"));
var import_prop_types10 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var UrlCondition = ({ operator, value }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
  children: [
    "path must ",
    OPERATOR_NAMES[operator],
    " ",
    value
  ]
});
UrlCondition.propTypes = {
  value: import_prop_types10.default.string.isRequired,
  operator: import_prop_types10.default.string.isRequired
};

// src/components/ReadableConditions/VersionCondition.jsx
var import_react32 = __toESM(require("react"));
var import_prop_types11 = __toESM(require("prop-types"));
var import_jsx_runtime = require("react/jsx-runtime");
var VersionCondition = ({ operator, value }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
  children: [
    "version must ",
    OPERATOR_NAMES[operator],
    " ",
    value
  ]
});
VersionCondition.propTypes = {
  value: import_prop_types11.default.string.isRequired,
  operator: import_prop_types11.default.string.isRequired
};

// src/components/ReadableConditions/PinCondition.jsx
var import_react33 = __toESM(require("react"));
var import_prop_types12 = __toESM(require("prop-types"));
var import_legacy_components23 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var PinCondition = ({
  operator,
  negated,
  pins,
  experienceStep: experienceStepId,
  Link = import_legacy_components23.Link
}) => {
  const negative = negated || operator === "!=";
  const { pin: pinFound, step: stepFound } = (0, import_react33.useMemo)(() => {
    return Object.values(pins != null ? pins : {}).map((pin) => ({
      pin,
      step: pin.steps.find(({ id }) => id === experienceStepId)
    })).find(({ step }) => step !== void 0) || null;
  }, [experienceStepId, pins]);
  const pinLink = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
    to: `/pins/${pinFound == null ? void 0 : pinFound.id}/analytics`,
    target: "_blank",
    children: (stepFound == null ? void 0 : stepFound.name) || experienceStepId
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "Pin ",
      pinLink,
      " has ",
      negative ? "not" : "",
      " been interacted with."
    ]
  });
};
PinCondition.propTypes = {
  experienceStep: import_prop_types12.default.string,
  operator: import_prop_types12.default.string.isRequired,
  pins: import_prop_types12.default.objectOf(import_prop_types12.default.any),
  negated: import_prop_types12.default.bool,
  Link: import_prop_types12.default.elementType
};
var PinCondition_default = PinCondition;

// src/components/ReadableConditions/MobileFlowCondition.jsx
var import_react34 = __toESM(require("react"));
var import_prop_types13 = __toESM(require("prop-types"));
var import_legacy_components24 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var MobileFlowCondition = ({
  operator,
  value,
  negated,
  experience: experienceId,
  mobiles,
  Link = import_legacy_components24.Link
}) => {
  var _a;
  const negative = negated || operator === "!=";
  const mobileFlowName = (_a = mobiles == null ? void 0 : mobiles[experienceId]) == null ? void 0 : _a.name;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "mobile flow",
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
        to: `/mobile/flows/${experienceId}/analytics`,
        target: "_blank",
        children: mobileFlowName || experienceId
      }),
      " ",
      "has ",
      negative ? "not" : "",
      " been ",
      value || "seen",
      "."
    ]
  });
};
MobileFlowCondition.propTypes = {
  experience: import_prop_types13.default.string,
  operator: import_prop_types13.default.string.isRequired,
  mobiles: import_prop_types13.default.objectOf(ExperienceShape),
  value: import_prop_types13.default.number,
  negated: import_prop_types13.default.bool,
  Link: import_prop_types13.default.elementType
};
var MobileFlowCondition_default = MobileFlowCondition;

// src/components/ReadableConditions/BannerCondition.jsx
var import_react35 = __toESM(require("react"));
var import_prop_types14 = __toESM(require("prop-types"));
var import_legacy_components25 = require("@studio/legacy-components");
var import_jsx_runtime = require("react/jsx-runtime");
var EXPERIENCE_DISMISSED = "permanently_dismissed";
var getBannerName = (value, experienceId, experiences, experienceStepId) => {
  var _a, _b;
  if (value === EXPERIENCE_DISMISSED)
    return ((_a = experiences == null ? void 0 : experiences[experienceId]) == null ? void 0 : _a.name) || experienceId;
  return ((_b = Object.values(experiences || {}).find(
    (experience) => experience.steps.some((step) => step.id === experienceStepId)
  )) == null ? void 0 : _b.name) || experienceStepId;
};
var BannerCondition = ({
  operator,
  negated,
  experienceStep: experienceStepId,
  experienceId,
  banners,
  value,
  Link = import_legacy_components25.Link
}) => {
  const negative = negated || operator === "!=";
  const bannerName = getBannerName(
    value,
    experienceId,
    banners,
    experienceStepId
  );
  const verb = value === EXPERIENCE_DISMISSED ? "dismissed" : "seen";
  const bannerLink = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Link, {
    to: `/banners/${experienceId}/analytics`,
    target: "_blank",
    children: bannerName || experienceStepId
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionText, {
    children: [
      "Banner ",
      bannerLink,
      " has ",
      negative ? "not" : "",
      " been ",
      verb,
      "."
    ]
  });
};
BannerCondition.propTypes = {
  experienceStep: import_prop_types14.default.string,
  experienceId: import_prop_types14.default.string,
  value: import_prop_types14.default.string,
  operator: import_prop_types14.default.string.isRequired,
  banners: import_prop_types14.default.objectOf(
    import_prop_types14.default.shape({
      name: import_prop_types14.default.string,
      steps: import_prop_types14.default.arrayOf(
        import_prop_types14.default.shape({
          id: import_prop_types14.default.string
        })
      )
    })
  ),
  negated: import_prop_types14.default.bool,
  Link: import_prop_types14.default.elementType
};
var BannerCondition_default = BannerCondition;

// src/components/ReadableConditions/ReadableConditions.jsx
var import_jsx_runtime = require("react/jsx-runtime");
var SUB_CONDITIONS = {
  checklists: ChecklistCondition_default,
  content: FlowCondition_default,
  domains: DomainCondition,
  event: EventCondition,
  groups: GroupCondition,
  languages: LanguageCondition_default,
  properties: PropertyCondition,
  segments: SegmentCondition_default,
  url: UrlCondition,
  version: VersionCondition,
  pins: PinCondition_default,
  mobile: MobileFlowCondition_default,
  banners: BannerCondition_default
};
var CONDITION_TYPE = {
  or: OrCondition,
  and: AndCondition
};
var ReadableConditions = ({ conditions, ...props }) => {
  const [[type, subConditions]] = Object.entries(conditions);
  if (["and", "or"].includes(type)) {
    return conditions[type].flatMap((clause, c) => {
      const ConditionType = CONDITION_TYPE[type];
      return [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SubGroup, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ReadableConditions, {
            conditions: clause,
            ...props
          })
        }, c),
        ...c < subConditions.length - 1 ? [/* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionType, {
          children: [
            " ",
            type,
            " "
          ]
        })] : []
      ];
    });
  }
  if (type === "not") {
    const [[subConditionType, negatedCondition]] = Object.entries(
      subConditions[0]
    );
    const conditionType2 = (negatedCondition == null ? void 0 : negatedCondition.type) || subConditionType;
    const SubCondition2 = SUB_CONDITIONS[conditionType2];
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SubCondition2, {
      negated: true,
      ...negatedCondition,
      ...props
    });
  }
  const conditionType = (subConditions == null ? void 0 : subConditions.type) || type;
  const SubCondition = SUB_CONDITIONS[conditionType];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SubCondition, {
    ...subConditions,
    ...props
  });
};
ReadableConditions.propTypes = {
  conditions: ConditionsShape,
  Link: import_prop_types15.default.elementType
};
var ReadableConditions_default = ReadableConditions;

// src/components/schema.js
var import_yup = require("yup");
var URLSchema = (0, import_yup.object)().shape({
  url: (0, import_yup.object)().shape({
    operator: (0, import_yup.string)().oneOf(["==", "!=", "*", "!*", "^", "!^", "$", "!$", "regex"]).required(),
    value: (0, import_yup.string)().when("operator", {
      is: (op) => ["==", "!=", "regex"].includes(op),
      then: (0, import_yup.string)().notRequired(),
      otherwise: (0, import_yup.string)().required()
    })
  })
});
var DomainsSchema = (0, import_yup.object)().shape({
  domains: (0, import_yup.object)().shape({
    operator: (0, import_yup.string)().matches(/==/).required(),
    value: (0, import_yup.string)().required()
  })
});
var PropertiesInnerSchema = (0, import_yup.object)().shape({
  property: (0, import_yup.string)().required(),
  operator: (0, import_yup.string)().oneOf([
    "==",
    "!=",
    ">",
    "<",
    "*",
    "!*",
    "^",
    "!^",
    "$",
    "!$",
    "?",
    "!?",
    "in",
    "not in",
    "since",
    "> ago",
    "< ago",
    "within",
    "> time",
    "< time",
    "regex"
  ]),
  value: (0, import_yup.string)().when("operator", {
    is: (op) => ["?", "!?", "==", "!=", "regex"].includes(op),
    then: (0, import_yup.string)().nullable().notRequired(),
    otherwise: (0, import_yup.string)().when("operator", {
      is: (op) => ["> ago", "< ago", "within", "> time", "< time"].includes(op),
      then: (0, import_yup.string)().matches(/\d+/).required(),
      otherwise: (0, import_yup.string)().required()
    })
  })
});
var PropertiesSchema = (0, import_yup.object)().shape({
  properties: PropertiesInnerSchema
});
var GroupSchema = (0, import_yup.object)().shape({
  group: PropertiesInnerSchema
});
var LanguagesSchema = (0, import_yup.object)().shape({
  languages: (0, import_yup.object)().shape({
    value: (0, import_yup.string)().min(2).max(5).required(),
    operator: (0, import_yup.string)().matches(/\^/).required()
  })
});
var ContentSchema = (0, import_yup.object)().shape({
  content: (0, import_yup.object)().shape({
    content: (0, import_yup.string)().required(),
    operator: (0, import_yup.string)().oneOf(["< ago", "since", ""]),
    times: (0, import_yup.number)(),
    value: (0, import_yup.number)().when("operator", {
      is: (op) => ["< ago", "since"].includes(op),
      then: (0, import_yup.number)().required()
    })
  })
});
var EventSchema = (0, import_yup.object)().shape({
  event: (0, import_yup.object)().shape({
    event: (0, import_yup.string)().required(),
    times: (0, import_yup.number)(),
    operator: (0, import_yup.string)().oneOf(["< ago", "since"]),
    value: (0, import_yup.number)().when("operator", {
      is: (op) => ["< ago", "since"].includes(op),
      then: (0, import_yup.number)().required(),
      otherwise: (0, import_yup.number)().notRequired()
    })
  })
});
var SegmentsSchema = (0, import_yup.object)().shape({
  segments: (0, import_yup.object)().shape({
    segment: (0, import_yup.string)().required()
  })
});
var ChecklistsSchema = (0, import_yup.object)().shape({
  checklists: (0, import_yup.object)().shape({
    checklist: (0, import_yup.string)().required(),
    status: (0, import_yup.string)().oneOf(["in_progress", "skipped", "completed dismissed", null]).nullable()
  })
});
var ExperienceSchema = (0, import_yup.object)().shape({
  experience: (0, import_yup.object)().shape({
    experience: (0, import_yup.string)().required(),
    type: (0, import_yup.string)().required()
  })
});
var AttributesSchema = (0, import_yup.object)().shape({
  attributes: (0, import_yup.object)().shape({
    attribute: (0, import_yup.string)().required(),
    operator: (0, import_yup.string)().oneOf([
      "==",
      "!=",
      "*",
      "!*",
      "^",
      "!^",
      "$",
      "!$",
      "?",
      "!?",
      "in",
      "not in",
      ">",
      "<",
      "regex"
    ]),
    value: (0, import_yup.string)().required()
  })
});
var AppSchema = (0, import_yup.object)().shape({
  app: (0, import_yup.object)().shape({
    operator: (0, import_yup.string)().oneOf(["=="]),
    value: (0, import_yup.string)().required()
  })
});
var ScreenSchema = (0, import_yup.object)().shape({
  screen: (0, import_yup.object)().shape({
    operator: (0, import_yup.string)().oneOf([
      "==",
      "!=",
      "*",
      "!*",
      "^",
      "!^",
      "$",
      "!$",
      "regex"
    ]),
    value: (0, import_yup.string)().required()
  })
});
var VersionSchema = (0, import_yup.object)().shape({
  screen: (0, import_yup.object)().shape({
    operator: (0, import_yup.string)().oneOf(["==", ">", "<"]),
    value: (0, import_yup.string)().required()
  })
});
var ExperienceStepSchema = (0, import_yup.object)().shape({
  experienceStep: (0, import_yup.object)().shape({
    experienceStep: (0, import_yup.string)().required(),
    type: (0, import_yup.string)().required()
  })
});
var AndSchema;
var OrSchema;
var NotSchema;
var TriggerSchema;
var ConditionsSchema = (0, import_yup.mixed)().test({
  name: "is-known-clause-type",
  test: (value) => {
    const [key] = Object.keys(value || {});
    const knownSchemas = {
      and: AndSchema,
      or: OrSchema,
      not: NotSchema,
      url: URLSchema,
      domains: DomainsSchema,
      properties: PropertiesSchema,
      group: GroupSchema,
      languages: LanguagesSchema,
      content: ContentSchema,
      event: EventSchema,
      segments: SegmentsSchema,
      checklists: ChecklistsSchema,
      experience: ExperienceSchema,
      trigger: TriggerSchema,
      attributes: AttributesSchema,
      app: AppSchema,
      screen: ScreenSchema,
      version: VersionSchema,
      experienceStep: ExperienceStepSchema
    };
    if (knownSchemas[key]) {
      return knownSchemas[key].validateSync(value);
    }
    return false;
  },
  message: "${path} is not a recognized clause"
});
TriggerSchema = (0, import_yup.object)().shape({
  trigger: (0, import_yup.object)().shape({
    event: (0, import_yup.string)().required(),
    conditions: (0, import_yup.lazy)(
      (conditions) => conditions ? ConditionsSchema : (0, import_yup.mixed)().notRequired()
    )
  })
});
AndSchema = (0, import_yup.object)().shape({
  and: (0, import_yup.array)().of(ConditionsSchema).required()
});
OrSchema = (0, import_yup.object)().shape({
  or: (0, import_yup.array)().of(ConditionsSchema).required()
});
NotSchema = (0, import_yup.object)().shape({
  not: (0, import_yup.array)().of(ConditionsSchema).required()
});
var schema_default = ConditionsSchema;

// src/components/Conditions.tsx
var import_react37 = require("react");
var import_styled_components5 = __toESM(require("styled-components"));

// src/components/GlobalStyle.ts
var import_styled_components4 = require("styled-components");
var GlobalStyle_default = import_styled_components4.createGlobalStyle`
  :root {
  /* FA */
  --glyphs: 'Font Awesome 5 Free';
  /* font-size scale */
  --xx-small: 10px;
  --x-small: 12px;
  --small: 13px;
  --regular: 14px;
  --medium-large: 16px;
  --large: 20px;
  --x-large: 24px;
  --xx-large: 32px;
  /* font-weight scale */
  --light: 300;
  --normal: 400;
  --medium: 500;
  --semi-bold: 600;
  --bold: 700;
  --extra-bold: 800;
  /* COLORS */
  /* blurple */
  --luna: #eeeeff;
  --lil-guest-bathroom-soaps: #d7d7ff;
  --blurple: #5c5cff;
  --deep-work: #4343c5;
  /* pink */
  --bubble-tape: #ffedf3;
  --blep: #ffb0d0;
  --pink-power-ranger: #ff5290;
  --motorola-razr: #d6216b;
  /* cutecumber */
  --ice-ice-baby: #e8fbfa;
  --lisa-frank: #b0f2f4;
  --cutecumber: #20e0d6;
  --sea-monsters: #1eb5c4;
  --bulbasaur: #0b818b;
  /* bludacris */
  --white-walker: #e9f7ff;
  --cotton-candy: #8ad5ff;
  --bludacris: #2cb4ff;
  --blues-cues-rgb: 13, 126, 249;
  --blues-cues: rgb(var(--blues-cues-rgb));
  --smurf-blood: #0b1a38;
  /* grayscale */
  --white: #ffffff;
  --noreaster: #f5f7fa;
  --myst: #e7ecf3;
  --dirty-water: #b0b6cf;
  --sharkbait-ooh-la-la: #627293;
  --pleather-rgb: 57, 68, 85; /* #394460 */
  --pleather: rgb(var(--pleather-rgb));
  --oh-hi-dark-rgb: 36, 42, 53; /* #242A35 */
  --oh-hi-dark: rgb(var(--oh-hi-dark-rgb));
  --dark-resting: #7e89a9;
  --light-gray: #d6dbe7;
  /* yellow */
  --cheeeese: #fff5cd;
  --rubber-ducky: #ffcd02;
  --orange-line: #ffb039;
  /* tints */
  --tint-white: rgba(255, 255, 255, 0.3);
  --tint-black: rgba(0, 0, 0, 0.1);
  /* gradients */
  --blurple-haze: #5c5cff 0%, #8960ff 100%;
  --merfolk: #0bb6d9 0%, #10d5cb 100%;
  --regulus: linear-gradient(90deg, #0b1a38 0%, #3b456a 100%);
  --daba-dee-daba-die: linear-gradient(90deg, #4980ff 0%, #2eb1ff 100%);
  --grapefruit: linear-gradient(90deg, #ff5290 0%, #ff8389 100%);
  --mithril: linear-gradient(90deg, #f4f7fa 0%, #ffffff 100%);
  --mood-lighting: linear-gradient(90deg, #5c5cff 0%, #8ad5ff 100%);
  --galaxy: linear-gradient(90deg, #5c5cff 0%, #ff92c6 98.25%);
  --tropico: linear-gradient(90deg, #ff5290 0%, #ff5290 0.01%, #8960ff 100%);
  --gradient-green: linear-gradient(90deg, #108484 0%, #00c2c2 100%);
  /* ELEVATIONS */
  --level-1: 0px 2px 6px rgba(71, 88, 114, 0.1);
  --level-2: 0px 4px 16px rgba(71, 88, 114, 0.16);
  --level-3: 0px 12px 34px rgba(71, 88, 114, 0.2);
  --level-4: 0px 12px 34px rgba(71, 88, 114, 0.35);
  --button-elevation: 0px 4px 16px rgba(11, 26, 56, 0.1);
  --basement: inset 0px 0px 2px rgba(71, 88, 114, 0.4);
  /* SEMANTIC VARS */
  /* background colors */
  --overlay: rgba(36, 42, 53, 0.4);
  --primary-x-light: var(--luna);
  --primary-light: var(--lil-guest-bathroom-soaps);
  --primary: var(--blurple);
  --primary-dark: var(--deep-work);
  --primary-grad: linear-gradient(90deg, var(--blurple-haze));
  --safety-x-light: var(--ice-ice-baby);
  --safety-light: var(--lisa-frank);
  --safety: var(--cutecumber);
  --safety-dark: var(--sea-monsters);
  --safety-grad: var(--gradient-green);
  --danger-x-light: var(--bubble-tape);
  --danger-light: var(--blep);
  --danger: var(--pink-power-ranger);
  --danger-dark: var(--motorola-razr);
  --danger-grad: var(--grapefruit);
  --secondary-x-light: var(--white-walker);
  --secondary-light: var(--cotton-candy);
  --secondary: var(--bludacris);
  --secondary-dark: var(--blues-cues);
  --disabled-x-light: var(--noreaster);
  --disabled-light: var(--myst);
  --disabled: var(--dirty-water);
  --disabled-dark: var(--sharkbait-ooh-la-la);
  --warn-light: var(--cheeeese);
  --warn: var(--rubber-ducky);
  --warn-dark: var(--orange-line);
  /* text colors */
  --text-primary: var(--oh-hi-dark);
  --text-secondary: var(--sharkbait-ooh-la-la);
  --text-tertiary: var(--dirty-water);
  --heading-primary: var(--pleather);
  --heading-secondary: var(--sharkbait-ooh-la-la);
  --icon: var(--sharkbait-ooh-la-la);
  --icon-hover: var(--pleather);
  --nav-hover: rgba(92, 92, 255, 1);
  --nav: rgba(92, 92, 255, 1);
  --nav-disabled: rgba(92, 92, 255, 0.7);
  --nav-width: 220px;
  --nav-border: rgba(0, 0, 0, 0.1);
  --nav-item-active: var(--noreaster);
  --link-hover: rgba(13, 126, 249, 1);
  --link: rgba(44, 180, 255, 1);
  --link-disabled: rgba(44, 180, 255, 0.7);
  --banner-text: var(--pleather);
  --error-hover: rgba(214, 33, 107, 1);
  --error: rgba(214, 33, 107, 1);
  --error-disabled: rgba(214, 33, 107, 0.7);
  --descriptive-list-text: var(--pleather);
  /* checkbox */
  --checkbox: var(--sharkbait-ooh-la-la);
  --checkbox-hover: var(--oh-hi-dark);
  --checkbox-checked: var(--blurple);
  --checkbox-checked-hover: var(--deep-work);
  --checkbox-disabled: var(--dirty-water);
  --checkbox-selected-focus-bg: var(--lil-guest-bathroom-soaps);
  --checkbox-unselected-focus-bg: var(--myst);
  --checkbox-group-hover: var(--noreaster);
  --checkbox-color: var(--pleather);
  --checkbox-star-color: var(--dark-resting);
  --checkbox-star-checked-color: var(--orange-line);
  /* radio */
  --radio: var(--sharkbait-ooh-la-la);
  --radio-hover: var(--oh-hi-dark);
  --radio-checked: var(--blurple);
  --radio-checked-hover: var(--deep-work);
  --radio-disabled: var(--dirty-water);
  --radio-selected-focus-bg: var(--lil-guest-bathroom-soaps);
  --radio-group-hover: var(--noreaster);
  /**
   * NOTE: This is the old color to keep consistency while we migrate inputs.
   *       This should be replaced with --sharkbait-ooh-la-la
   */
  /* input */
  --input: var(--sharkbait-ooh-la-la);
  --input-text: var(--pleather);
  --input-focus: var(--oh-hi-dark);
  --input-disabled: var(--sharkbait-ooh-la-la);
  --input-disabled-bg: var(--noreaster);
  --input-clear-icon-color: var(--dark-resting);
  --input-light-border: var(--light-gray);
  --input-light-bg: var(--white);
  /* charts */
  --tooltip-header-bg: var(--noreaster);
  --tooltip-header-color: var(--pleather);
  /* select/dropdowns */
  --dropdown-bg: var(--white);
  --dropdown-text: var(--pleather);
  --dropdown-active: var(--oh-hi-dark);
  --dropdown-inactive: var(--sharkbait-ooh-la-la);
  --dropdown-disabled: var(--noreaster);
  --dropdown-disabled-text: var(--dirty-water);
  --dropdown-placeholder: var(--sharkbait-ooh-la-la);
  --dropdown-menu-shadow: var(--level-3);
  --dropdown-option-bg: var(--noreaster);
  --dropdown-option-selected: var(--blurple);
  --dropdown-icon: var(--sharkbait-ooh-la-la);
  /* accents */
  --ui-vertical-separator: var(--myst);
  --ui-horizontal-separator: var(--tint-black);
  /* nps colors */
  --nps-promoters: var(--sea-monsters);
  --nps-promoters-light: var(--ice-ice-baby);
  --nps-passives: var(--dirty-water);
  --nps-passives-light: var(--noreaster);
  --nps-detractors: var(--motorola-razr);
  --nps-detractors-light: var(--bubble-tape);
  --nps-no-responses: var(--dirty-water);
  /* tables */
  --table-text: var(--pleather);
  --table-border: var(--tint-black);
  --table-header-hover: var(--noreaster);
  --table-header-sorted: var(--smurf-blood);
  --table-row-expanded: var(--noreaster);
  /* status indicators */
  --status-text: var(--pleather);
  --status-active: var(--cutecumber);
  --status-active-bg: var(--ice-ice-baby);
  --status-inactive: var(--sharkbait-ooh-la-la);
  --status-inactive-bg: var(--noreaster);
  /* pagination */
  --pagination: var(--noreaster);
  --pagination-focus: var(--myst);
  --pagination-selected: var(--bludacris);
  --pagination-arrow: var(--sharkbait-ooh-la-la);
  /* date picker */
  --datepicker-color: var(--pleather);
  --datepicker-hover: var(--myst);
  --datepicker-header-bg: var(--noreaster);
  --datepicker-weekday-color: var(--sharkbait-ooh-la-la);
  --datepicker-outside-color: var(--myst);
  --datepicker-selected-bg: var(--luna);
  --datepicker-selected-hover: var(--lil-guest-bathroom-soaps);
  --datepicker-selected-border: var(--deep-work);
  --datepicker-disabled-bg: var(--noreaster);
  --datepicker-disabled-color: var(--sharkbait-ooh-la-la);
  --datepicker-label: var(--sharkbait-ooh-la-la);
  --datepicker-separator: var(--dirty-water);
  --datepicker-footer-bg: var(--white-walker);
  /* tooltip */
  --tooltip-bg: var(--smurf-blood);
  --tooltip-color: var(--white);
  --tooltip-caret-width: 6px;
  /* button */
  --square-button-bg: var(--luna);
  /* Switch */
  --switch-bg: rgba(var(--pleather-rgb), 0.35);
  --switch-hover-bg: rgba(var(--oh-hi-dark-rgb), 0.35);
  --switch-dot-bg: var(--white);
  --switch-dot-hover-bg: var(--myst);
  --switch-checked-bg: var(--cotton-candy);
  --switch-dot-checked-bg: var(--bludacris);
  --switch-checked-hover-bg: rgba(var(--blues-cues-rgb), 0.35);
  --switch-dot-checked-hover-bg: var(--blues-cues);
  --switch-disabled-bg: var(--myst);
  --switch-dot-disabled-bg: var(--white);
  --switch-disabled-checked-bg: var(--white-walker);
  --switch-dot-disabled-checked-bg: var(--cotton-candy);
  /* Progress */
  --progress-light: var(--noreaster);
  --progress-dark: var(--white);
  --progress-success: linear-gradient(90deg, var(--merfolk));
  --progress-error: var(--grapefruit);
  --progress-default: linear-gradient(90deg, var(--blurple-haze));
  /* Click to copy */
  --copy-alert-bg: var(--smurf-blood);
  /* User Profile */
  --activity-started-color: var(--orange-line);
  --activity-completed-color: var(--cutecumber);
  --activity-skipped-color: var(--motorola-razr);
  --activity-triggered-color: var(--blurple);
  --eligible-icon-color: var(--sea-monsters);
  --ineligible-icon-color: var(--dark-resting);
  --select-identifier-icon-color: var(--blurple);
  --criteria-type-color: var(--sharkbait-ooh-la-la);
  --ineligible-color: var(--error-hover);
  --see-more-link-color: var(--white);
  --profile-link-icon-color: var(--blurple);
  /* Skeleton */
  --skeleton-gradient: linear-gradient(
    to right,
    #f4f7fa 20%,
    #e7ecf3 50%,
    #f4f7fa 80%
  );
  --skeleton-icon: var(--dark-resting);
  /* Banner */
  --banner-info-gradient: linear-gradient(90deg, var(--blurple-haze));
  --banner-negative-gradient: linear-gradient(90deg, #d6216b 0%, #ff5290 100%);
  --banner-content: var(--white);
  /* Tab Navigation */
  --tab-text: var(--pleather);
  --tab-hover: var(--blurple);
  --tab-active: var(--blurple);
  --tab-disabled-hover: var(--oh-hi-dark);
  /* Navigation */
  --nav-install-color: var(--pleather);
  --nav-install-bg: var(--luna);
  --nav-install-hover: var(--lil-guest-bathroom-soaps);
  --nav-install-icon-color: var(--blurple);
  --nav-install-icon-hover: var(--deep-work);
  --nav-spoof-hover: var(--lil-guest-bathroom-soaps);
}
`;

// src/components/Conditions.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var CONDITION_OPTIONS = [
  { label: "And", value: "and" },
  { label: "Or", value: "or" }
];
var Conditions = ({
  bannerOptions = [],
  checklistOptions = [],
  eventOptions = [],
  flowOptions = [],
  groupOptions = [],
  hasBannerTargeting = false,
  hasChecklistTargeting = false,
  mobileFlowOptions = [],
  pinOptions = [],
  propertyOptions = [],
  segmentOptions = [],
  conditionsOptions = CONDITION_OPTIONS,
  validClauseTypes = Object.keys(CLAUSE_TYPES),
  propertiesClauseOperators = ALL_OPERATORS,
  onAttributeChange = () => Promise.resolve([]),
  ...unhandledProps
}) => {
  const { conditions = { and: [] } } = unhandledProps;
  const canTargetChecklists = (0, import_react37.useMemo)(() => {
    const isTargetingChecklists = getLeafNodes(conditions).some(
      (clause) => Object.hasOwn(clause, "checklists")
    );
    return isTargetingChecklists || hasChecklistTargeting;
  }, [conditions, hasChecklistTargeting]);
  const canTargetBanners = (0, import_react37.useMemo)(() => {
    const isTargetingBanner = getLeafNodes(conditions).some(
      (clause) => Object.hasOwn(clause, "experienceStep") && clause.experienceStep.type === "banners"
    );
    return isTargetingBanner || hasBannerTargeting;
  }, [conditions, hasBannerTargeting]);
  const context = (0, import_react37.useMemo)(
    () => ({
      canTargetChecklists,
      canTargetBanners,
      checklistOptions,
      eventOptions,
      flowOptions,
      mobileFlowOptions,
      groupOptions,
      hasChecklistTargeting,
      languageOptions: LANGUAGE_OPTIONS,
      propertyOptions,
      segmentOptions,
      pinOptions,
      bannerOptions,
      conditionsOptions,
      validClauseTypes,
      propertiesClauseOperators,
      onAttributeChange
    }),
    [
      checklistOptions,
      canTargetBanners,
      canTargetChecklists,
      eventOptions,
      flowOptions,
      mobileFlowOptions,
      groupOptions,
      hasChecklistTargeting,
      propertyOptions,
      segmentOptions,
      pinOptions,
      bannerOptions,
      conditionsOptions,
      validClauseTypes,
      propertiesClauseOperators,
      onAttributeChange
    ]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ConditionsContext.Provider, {
    value: context,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GlobalStyle_default, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Group, {
        ...unhandledProps
      })
    ]
  });
};
var Conditions_default = (0, import_styled_components5.default)(Conditions)``;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ABSOLUTE_TIME_OPERATORS,
  ALL_OPERATORS,
  AUDIENCES_CLAUSES,
  AndCondition,
  AndShape,
  AppShape,
  AttributesShape,
  CLAUSE_TYPES,
  ChecklistsShape,
  ConditionText,
  Conditions,
  ConditionsPropsShape,
  ConditionsShape,
  ContentShape,
  DEFAULT_OPERATORS,
  DomainsShape,
  EXISTENTIAL_OPERATORS,
  EventShape,
  ExperienceShape,
  ExperienceStepShape,
  FrequencyShape,
  GroupsShape,
  Highlight,
  LANGUAGE_OPTIONS,
  LanguagesShape,
  MILLISECONDS_PER_DAY,
  MULTI_VALUE_OPERATORS,
  NUMERIC_OPERATORS,
  NotShape,
  OPERATORS,
  OptionShape,
  OrCondition,
  OrShape,
  PROPERTY_CLAUSE_OPERATORS,
  PropertiesShape,
  RELATIVE_TIME_OPERATORS,
  ReadableConditions,
  STEP_TYPE_IDS,
  ScreenShape,
  SegmentsShape,
  SelectOptionsShape,
  Shape,
  SubGroup,
  TriggerShape,
  URLShape,
  VersionShape,
  allowed,
  conditionsSchema,
  evaluate,
  filterImmutableExperienceSections,
  getAudienceConditions,
  getBannerTargetingSections,
  getCompletionEventLabel,
  getDomains,
  getLaunchpadTargetingSections,
  getLeafNodes,
  getMobileTargetingSections,
  getPinTargetingSections,
  getSegments,
  hasMatchingSegment,
  isGroupList,
  isGroupOption,
  parse
});
//# sourceMappingURL=index.js.map